export const fr = {
    "app_name": "DiRIF",
    "fiches": "Fiches",
    "syntheses": "Synthèses",
    "home": "Tableau de bord",
    "perimetres": "Périmètres",
    "back": "Retour",
    "cancel": "Annuler",
    "send": "Envoyer",
    "yes": "Oui",
    "no": "Non",
    "close": "Fermer",
    "created_at": "Créé le",
    "validate": "Valider",
    "reset": "Réinitialiser",
    "submit": "Soumettre",
    "choose": "Choisir",
    "duplicate": "Dupliquer",
    "copy": "Copier",
    "paste": "Coller",
    "options": "Options",
    "create": "Créer",
    "add": "Ajouter",
    "update": "Modifier",
    "save": "Enregistrer",
    "refuse": "Refuser",
    "manage": "Gérer",
    "warning": "Attention",
    "download_excel_full": "Télécharger le fichier complet",
    "download_excel": "Télécharger",
    "download_excel_custom": "Télécharger le fichier personnalisé",
    "download_pdf": "Télécharger (PDF)",
    "error_download_synthese": "Erreur lors du téléchargement de la synthèse.",
    "archive": "Archiver",
    "save_draft": "Enregistrer comme brouillon",
    "validate_temp": "Valider",
    "validate_def": "Valider définitivement",
    "validate_send": "Valider et envoyer",
    "delete_confirm": "Êtes-vous sûr de vouloir supprimer {item} ?",
    "field_required": "Le champ {0} est requis",
    "error_min_date": "Le champ {0} dépasse la date minimale autorisée",
    "error_max_date": "Le champ {0} dépasse la date maximale autorisée",
    "bad_format": "Le format du champ {0} n'est pas correct",
    "min_max_length": "Le champ {0} doit faire entre {1} et {2} caractères",
    "min_length": "Le champ {0} doit faire au moins {1} caractère(s)",
    "max_length": "Le champ {0} ne doit pas faire plus de {1} caractère(s)",
    "min_max_value": "Le champ {0} doit être compris entre {1} et {2}",
    "min_value": "Le champ {0} doit être supérieur ou égal à {1}",
    "max_value": "Le champ {0} doit être inférieur ou égal à {1}",
    "bad_type": "Le champ {0} doit être {1}",
    "check_phone_number": 'Merci de vérifier le format du numéro de téléphone',
    "type_integer": "un nombre entier",
    "login_not_found": "Utilisateur inconnu, merci de vérifier vos identifiants",
    "bad_pwd": "Merci de vérifier votre mot de passe",
    "unauthorized": "Non autorisé",
    "unknown_error": "Une erreur est survenue",
    "login_already_exists": "Le login/mail existe déjà",
    "error_affectation_needed": "Une affection est requise",
    "pwd_current": "Vérification de votre mot de passe actuel",
    "pwd_new1": "Nouveau mot de passe",
    "pwd_new2": "Répéter le nouveau mot de passe",
    "email_new1": "Nouvelle adresse mail",
    "email_new2": "Répéter la nouvelle adresse mail",
    "sign_in": "Se connecter",
    "interventions": "Interventions",
    "pwd_forget": "Mot de passe oublié ?",
    "goto_table": "Voir le tableau",
    "confirm_archive": "Êtes-vous sûr de vouloir archiver l'ensemble des données de l'année en cours ?",
    "archive_dialog": "Archivage des données",
    "archived": "Les données de l'année ont été archivées",
    "undefined": "Non défini",
    "undefined_short": "ND",
    "choose_file": "Choisir",
    "add_file": "Ajouter",
    "import_file": "Importer",
    "import": "Importer",
    "cancel_file": "Annuler",
    "drag_files": "Faites glisser vos fichiers",
    error_download: "Erreur lors du téléchargement",
    "details": "Détails",
    "pwd_forget_enter_mail": "Saisissez votre adresse mail",
    "reset_pwd_err_empty": "Vous devez saisir un mot de passe",
    "reset_pwd_err_confirm": "Vous devez saisir deux fois le même mot de passe",
    "reset_pwd_err_invalid": "Votre mot de passe est invalide",
    "reset_email_err_empty": "Vous devez saisir une adresse mail",
    "reset_email_err_confirm": "Vous devez saisir deux fois la même adresse mail",
    "reset_email_err_invalid": "Votre  est invalide",
    "reset_pwd_perform": "Changer le mot de passe",
    "reset_email_perform": "Changer l'adresse mail",
    "changepwd_title": "Changement de mot de passe",
    "changepwd_success": "Changement de mot de passe effectué avec succès",
    "changeemail_success": "Changement d'adresse mail effectué avec succès",
    "file_confirm_delete": "Êtes-vous sûr de vouloir supprimer le fichier {item} ?",
    "badpwd_previous": "Vérifiez votre mot de passe actuel",
    "badpwd_empty": "Le mot de passe n'est pas renseigné",
    "bademail_empty": "L'email n'est pas renseigné",
    "list_empty": "Aucune donnée à afficher",
    "search_here": "Rechercher ici",
    "classic_daily_overview_label": "Quotidiennes Classiques",
    "modernized_daily_overview_label": "Quotidiennes Modernisées",
    "weekly_overview_label": "Hebdomadaires",
    "vh_reviews": "Bilans VH",
    "circuit_review": "Bilan des circuits",
    "healthcare_review": "Organisation des conditions de travail des personnels",
    "crisis_review": "Périodes de gestion de crise",
    "formation_review": "Bilan des formations",
    "materiel_review": "Bilan du matériel",
    "help": "Aide",
    "actualite_label": "Gestion des actualités",
    "ager_label": "AGER",
    "uer_label": "UER",
    "cei_label": "CEI",
    "type_vh": "Type VH",
    "circuit_label": "Circuit",
    "circuits_label": "Circuits",
    "sections": "Sections",
    "axis": "Axes",
    "users": "Utilisateurs",
    "agents": "Agents",
    "user_groups": "Groupes utilisateurs",
    "group": "Groupe",
    "year": "Année",
    "current_year": "Année courante",
    "date": "Date",
    "date_after": "Jusqu'au",
    "period_day": "Journée du {0}",
    "period_night": "Nuit du {0} au {1}",
    "day_night": "Moment de la mission",
    "type_vh_label": "Type de circuit VH",
    "type_vh_display_label": "Afficher les circuits par type VH",
    "administration": "Administration",
    "epi": "EPI",
    "epi_admin": "Administration des EPI",
    "epi_manage": "Gestion des EPI",
    "ceiAgentManagment": "Gestion des agents",
    "comment": "Commentaire",
    "see_all": "Tout voir",
    "see_mine": "Voir les miens",
    "see_mine_f": "Voir les miennes",
    "required_fields_empty": "Certains champs obligatoires sont vides (surlignés en rouge)",
    "fields_size_error": "Certains champs sont trop longs (surlignés en rouge)",
    "settings_saved": "Paramètres enregistrés",
    "settings_not_saved": "Paramètres non enregistrés",
    "agent": "Agent",
    "author": "Auteur",
    "reset_filter": "Réinitialiser les filtres",
    "filter_reset_success": "Filtres réinitialisés",
    "date_range": "Période",
    "impossible_to_update_archived_sheet": "Impossible de modifier une fiche archivée",
    "add_affectation_dialog": "Ajouter une affectation",
    "import_key": "Clé d'import",
    "alerts": "Alertes",
    max_size_chars: "{0}/{1} caractères utilisés ({2} restants)",
    "user": {
        date_created: "Date de création",
        date_updated: "Date de dernière modification",
        date_charte_acceptee: "Date d'acceptation de la charte",
        date_charte_non_acceptee_placeholder: "Charte non acceptée",
        "profile": "Profil d'utilisateur",
        "no_file_selected": "Aucun fichier n'a été sélectionné",
        "create_dialog": "Création d'un utilisateur",
        "update_dialog": "Modification de l'utilisateur",
        "delete_dialog": "Suppression de l'utilisateur",
        "import_dialog": "Import des utilisateurs",
        "no_import_file_selected": "Aucun fichier sélectionné pour l'import",
        "import_success": "Import réussi",
        "import_error": "Erreur lors de l'import",
        "import_error_file_format": "Erreur lors de l'import. Vérifiez le format du fichier importé",
        "import_error_empty_file": "Erreur lors de l'import. Le fichier est vide",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer l'utilisateur",
        "list": "Liste des utilisateurs",
        "details": "Fiche utilisateur",
        "one": "Utilisateur",
        "empty": "Aucun utilisateur",
        "name": "Nom",
        "first_name": "Prénom",
        "last_name": "Nom",
        "hierarchie": "Responsable hiérarchique",
        "codeDotation": "Code dotation",
        "service_ager": "Service / AGER",
        "departement_uer": "Département / UER",
        "unite_cei": "Unité / CEI",
        "code_poste": "Code poste",
        "intitule_poste": "Intitulé du poste",
        "groups": "Groupes",
        "activities": "Activités",
        "password": "Mot de passe",
        "password_edition": "Mot de passe (inchangé par défaut)",
        "password_new": "Nouveau mot de passe",
        "password_previous": "Mot de passe actuel",
        "password_repeat": "Confirmation du mot de passe",
        "email": "E-mail",
        "emailLogin": "E-mail (Login)",
        "tel": "Téléphone",
        "roleKey": "Rôle",
        "enabled": "Actif",
        "access": "Accès propriétaire",
        "add": "Ajouter un utilisateur",
        "update": "Modifier un utilisateur",
        "added": "Utilisateur ajouté",
        "created": "Utilisateur créé",
        "updated": "Utilisateur modifié",
        "deleted": "Utilisateur supprimé",
        "imported": "Liste des utilisateurs importée",
        "exported": "Liste des utilisateurs exportée",
        "my_profile": "Mon profil",
        "ug_label": "Groupes d'utilisateurs",
        "exportList": "Exporter la liste",
        "importList1": "Importer l'organigramme",
        "importList2": "Importer l'annuaire",
        "affectations_not_valid": "La configuration minimale de l'affectation pour les groupes de cet utilisateur n'est pas respectée.",
        "affectation_already_exists": "L'affectation existe déjà pour cet utilisateur",
        "ager_required": "Un AGER est obligatoire pour les groupes de cet utilisateur.",
        "uer_required": "Un UER est obligatoire pour les groupes de cet utilisateur.",
        "cei_required": "Un CEI est obligatoire pour les groupes de cet utilisateur.",
        "mandatory_field_depends_on_group": "Les champs obligatoires dépendent du/des groupe(s) de l'utilisateur",
        "service": "Service",
        "departement": "Département",
        "unite": "Unité",
        "ager_type": "Agent au sein d'un AGER",
        "show_users": "Afficher les utilisateurs",
        "all": "Tous",
        "validated": "Validés",
        "not_validated": "Non validés",
        nouvelArrivant: "Nouvel arrivant",
    },
    "agentList": {
        "profile": "Profil d'utilisateur",
        "no_file_selected": "Aucun fichier n'a été sélectionné",
        "create_dialog": "Création d'un agent",
        "update_dialog": "Modification de l'agent",
        "validate_dialog": "Validation de l'agent",
        "delete_dialog": "Suppression de l'agent",
        "import_dialog": "Import des utilisateurs",
        "no_import_file_selected": "Aucun fichier sélectionné pour l'import",
        "import_success": "Import réussi",
        "import_error": "Erreur lors de l'import",
        "import_error_file_format": "Erreur lors de l'import. Vérifiez le format du fichier importé",
        "import_error_empty_file": "Erreur lors de l'import. Le fichier est vide",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer l'agent",
        "list": "Liste des agents",
        "details": "Fiche utilisateur",
        "one": "Agent",
        "empty": "Aucun agent",
        "name": "Nom",
        "first_name": "Prénom",
        "last_name": "Nom",
        "service_ager": "Service / AGER",
        "departement_uer": "Département / UER",
        "unite_cei": "Unité / CEI",
        "code_poste": "Code poste",
        "intitule_poste": "Intitulé du poste",
        "groups": "Groupes",
        "activities": "Activités",
        "hierarchie": "Responsable hiérarchique",
        "codeDotation": "Code dotation",
        "password": "Mot de passe",
        "password_edition": "Mot de passe (inchangé par défaut)",
        "password_new": "Nouveau mot de passe",
        "password_previous": "Mot de passe actuel",
        "password_repeat": "Confirmation du mot de passe",
        "email": "E-mail",
        "emailLogin": "E-mail (Login)",
        "tel": "Téléphone",
        "roleKey": "Rôle",
        "enabled": "Actif",
        "access": "Accès propriétaire",
        "add": "Ajouter un agent",
        "update": "Modifier un agent",
        "added": "Agent ajouté",
        "created": "Agent crée",
        "updated": "Agent modifié",
        "deleted": "Agent supprimé",
        "imported": "Liste des agents importée",
        "exported": "Liste des agents exportée",
        "my_profile": "Mon profil",
        "ug_label": "Groupes d'utilisateurs",
        "exportList": "Exporter la liste",
        "importList": "Importer la liste",
        "affectations_not_valid": "La configuration minimale de l'affectation pour les groupes de cet utilisateur n'est pas respectée.",
        "affectation_already_exists": "L'affectation existe déjà pour cet utilisateur",
        "ager_required": "Un AGER est obligatoire pour les groupes de cet utilisateur.",
        "uer_required": "Un UER est obligatoire pour les groupes de cet utilisateur.",
        "cei_required": "Un CEI est obligatoire pour les groupes de cet utilisateur.",
        "mandatory_field_depends_on_group": "Les champs obligatoires dépendent du/des groupe(s) de l'utilisateur",
        "service": "Service",
        "departement": "Département",
        "unite": "Unité",
        "ager_type": "Agent au sein d'un AGER",
        "show_agents": "Afficher les agents",
        "all": "Tous",
        "validated": "Validés",
        "not_validated": "Non validés",
        nouvelArrivant: "Nouvel arrivant",
    },
    "actualite": {
        "title": "Titre",
        "creator": "Auteur",
        "content": "Texte",
        "dateStart": "Date de début de publication",
        "dateEnd": "Date de fin de publication",
        "list": "Liste des actualités",
        "added": "L'actualité a été ajoutée",
        "updated": "L'actualité a été modifiée",
        "deleted": "L'actualité a été supprimée",
        "create_dialog": "Création d'une actualité",
        "edit_dialog": "Édition de l'actualité",
        "delete_dialog": "Suppression de l'actualité",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer l'actualité ?",
    },
    "ager": {
        "label": "Libellé",
        "list": "Liste des AGER",
        "added": "L'AGER a été ajouté",
        "updated": "L'AGER a été modifié",
        "deleted": "L'AGER a été supprimé",
        "create_dialog": "Création d'un AGER",
        "edit_dialog": "Édition de l'AGER",
        "delete_dialog": "Suppression de l'AGER",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer l'AGER ?",
    },
    "uer": {
        "label": "Libellé",
        "list": "Liste des UER",
        "added": "L'UER a été ajouté",
        "updated": "L'UER a été modifié",
        "deleted": "L'UER a été supprimé",
        "create_dialog": "Création d'un UER",
        "edit_dialog": "Édition de l'UER",
        "delete_dialog": "Suppression de l'UER",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer l'UER ?",
    },
    "cei": {
        "label": "Libellé",
        "list": "Liste des CEI",
        "added": "Le CEI a été ajouté",
        "updated": "Le CEI a été modifié",
        "deleted": "Le CEI a été supprimé",
        "create_dialog": "Création d'un CEI",
        "edit_dialog": "Édition du CEI",
        "delete_dialog": "Suppression du CEI",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer le CEI ?",
    },
    "circuit": {
        "label": "Libellé",
        "axis": "Axe",
        "number": "Numéro de circuit",
        "section": "Section",
        "list": "Liste des circuits",
        "added": "Le circuit a été ajouté",
        "updated": "Le circuit a été modifié",
        "deleted": "Le circuit a été supprimé",
        "create_dialog": "Création d'un circuit",
        "edit_dialog": "Édition du circuit",
        "delete_dialog": "Suppression du circuit",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer le circuit ?",
        "delete_selected_circuits": "Supprimer les circuits sélectionnés",
        "delete_selected_dialog": "Suppression des circuits",
        "no_circuit_selected": "Aucun circuit sélectionné",
        "too_many_circuits_selected": "Vous ne pouvez pas supprimer plus de 50 circuits à la fois",
        "circuits_deleted": "Les circuits sélectionnés ont été supprimés",
        "circuits_not_deleted": "Les circuits n'ont pas pu être supprimés",
        "confirm_delete_selected": "Êtes-vous sûr de vouloir supprimer les circuits sélectionnés ?",
        "deleted_failed": "Le circuit n'a pas pu être supprimé",
        "download_excel": "Télécharger",
    },
    "data_show_type": {
        "show_choice": "Type de données",
        "all": "Tout montrer",
        "redacting": "En rédaction",
        "archived": "Archivées",
        "validated": "Validées",
        "per_day": "Par jour",
    },
    "forecast_sheet": {
        "title": "Prévisions",
        "update_this": "Modifier",
        "hours": "Heures",
        "created_by": "Créée par",
        "updated_by": "Mise à jour par",
        "validated_by": "Validée par",
        "list": "Fiches de prévisions",
        "details": "Détails de la fiche de prévision N°{0}",
        "patrol_start": "Heure de début de patrouille",
        "precurative_start": "Heure de début de précuratif",
        "curative_start": "Heure de début de curatif",
        "intervention_observation": "Précisions complémentaires",
        "forecast_observation": "Observations (ex: état de chaussée, prévision de couverture nuageuse, refroidissement, prévision de neige...)",
        "weekend_activation": "Prévision d'activation pour le week-end",
        "weather_forecast": "Prévisions météorologiques",
        "files": "Fichiers",
        "additional_files": "Fichiers supplémentaires",
        "intervention_forecast": "Prévisions d'interventions",
        "creator_name": "Nom du créateur de la fiche",
        "creator_tel": "Téléphone du créateur de la fiche",
        "forecast_per_hour": "Prévisions par heures",
        "history": "Historique",
        "status": "Statut",
        "comment": "Commentaire",
        "comments": "Commentaires",
        "weekend": "Activation pour le week-end",
        "weekend_motif": "Motif",
        "validation_comment": "Commentaire de validation",

        "create": "Création d'une fiche de prévision",
        "update": "Édition de la fiche de prévision N°{0}",
        "add_comment": "Commenter",
        "download": "Télécharger",
        "export": "Exporter",
        "download_failed": "Erreur lors du téléchargement",
        "added": "La fiche de prévision a été enregistrée comme brouillon",
        "added_validated": "La fiche de prévision a été validée et envoyée",
        "updated": "La fiche de prévision a été enregistrée comme brouillon",
        "updated_validated": "La fiche de prévision a été validée et envoyée",
        "deleted": "La fiche de prévision a été supprimée",
        "deleted_failed": "La fiche de prévision ne peut être supprimée",
        "forecast_sheets_deleted": "Les fiches de prévision auxquelles vous avez accès ont été supprimées",
        "forecast_sheets_not_deleted": "Les fiches de prévision n'ont pas été supprimées",
        "delete_selected_forecast_sheets": "Supprimer les fiches de prévision sélectionnées",
        "no_forecast_sheet_selected": "Aucune fiche de prévision sélectionnée",
        "too_many_forecast_sheets_selected": "Vous ne pouvez pas supprimer plus de 50 fiches de prévision à la fois",
        "validated": "La fiche de prévision a été validée",
        "commented": "Commentaire ajouté",

        "delete_dialog": "Suppression de la fiche de prévision",
        "validate_dialog": "Validation de la fiche de prévision",
        "comment_dialog": "Commentaire pour la fiche de prévision",

        "confirm_delete": "Êtes-vous sûr de vouloir supprimer la fiche de prévision ?",
        "confirm_validation": "Êtes-vous sûr de vouloir valider la fiche de prévision ? Vous ne pourrez plus modifier les informations saisies.",
        "confirm_temp_validation": "Êtes-vous sûr de vouloir valider la fiche de prévision ?",
        "no_fiche": "N° de fiche",
        "error": {
            "create": "Erreur lors de la création de la fiche de prévision. Veuillez vérifier le formulaire.",
            "update": "Erreur lors de la modification de la fiche de prévision. Veuillez vérifier le formulaire.",
        }
    },
    "forecast_row": {
        "hour": "Heure",
        "ground_temp": "Température du sol (°C)",
        "air_temp": "Température de l'air (°C)",
        "humidity": "Humidité relative (%)",
        "ground_temp_short": "Sol (°C)",
        "air_temp_short": "Air (°C)",
        "humidity_short": "Hr (%)",
        "list": "Enregistrements",
        "details": "Détails de l'enregistrement",
        "add": "Ajout d'un enregistrement",
        "add_row": "Ajouter une prévision",
        "delete_dialog": "Suppression de la prévision",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer la prévision ?",
    },
    "link_sheet": {
        "title": "Liaisons",
        "created_by": "Créée par",
        "updated_by": "Mise à jour par",
        "validated_by": "Validée par",
        "circuits": "Circuits",
        "list": "Fiches de liaisons",
        "details": "Détails de la fiche de liaison N°{0}",
        "update_this": "Modifier",
        "road_weather": "Météorologie routière",
        "treatment_strategy": "Stratégie de traitement",
        "traffic_conditions": "Conditions de conduite hivernale",
        "freezing_humidity": "Congélation d'humidité préexistante",
        "ground_frost": "Gelée blanche",
        "strategie_traitement": "Stratégie de traitement",
        "rain_on_frozen_ground": "Pluie sur sol gelé",
        "rain_on_surfusion": "Pluie en surfusion",
        "freezing_fog": "Brouillard givrant",
        "ground_temp": "Température du sol (°C)",
        "air_temp": "Température de l'air (°C)",
        "relative_humidity": "Humidité relative (%)",
        "observations": "Observations",
        "alert_hour": "Heure d'alerte",
        "start_hour": "Heure de début",
        "end_hour": "Heure de fin",
        "dry_salt_tonnage": "Tonnage de sel sec (indiquer le poids en tonne)",
        "brine_liters": "Litres de saumures",
        "agent_number": "Nombre d'agent dans l'équipe d'intervention",
        "patrol": "Patrouille",
        "precurative": "Précuratif",
        "curative": "Curatif",
        "scraping": "Raclage",
        "alertes": "Alertes",
        "singular_points": "Points singuliers",
        "history": "Historique",
        "download": "Télécharger",
        "export": "Exporter",
        "status": "Statut",
        "type": "Type de fiche",
        "settings_dialog": "Paramètres d'exports des fiches de liaison",
        "add": "Création de fiche de liaison",
        "update": "Modification de fiche de liaison N°{0}",
        
        "added": "La fiche de liaison a été enregistrée comme brouillon",
        "added_validated": "La fiche de liaison a été validée et envoyée",
        "updated": "La fiche de liaison a été modifiée",
        "updated_validated": "La fiche de liaison a été modifiée et validée",
        "deleted": "La fiche de liaison a été supprimée",
        "deleted_failed": "La fiche de liaison ne peut être supprimée",
        "link_sheets_deleted": "Les fiches de liaison auxquelles vous avez accès ont été supprimées",
        "link_sheets_not_deleted": "Les fiches de liaison n'ont pas été supprimées",
        "delete_selected_link_sheets": "Supprimer les fiches de liaison sélectionnées",
        "no_link_sheet_selected": "Aucune fiche de liaison sélectionnée",
        "too_many_link_sheets_selected": "Vous ne pouvez pas supprimer plus de 50 fiches de liaison à la fois",
        "validated": "La fiche de liaison a été validée",

        "delete_dialog": "Suppression de la fiche de liaison",
        "validate_dialog": "Validation de la fiche de liaison",

        "confirm_delete": "Êtes-vous sûr de vouloir supprimer la fiche de liaison ?",
        "confirm_validation": "Êtes-vous sûr de vouloir valider la fiche de liaison ? Vous ne pourrez plus modifier les informations saisies.",
        "confirm_validation_alerte1": "Vous avez renseigné une température du sol > 0°C et indiqué une stratégie de traitement par du sel.",
        "confirm_validation_alerte2": "Vous avez renseigné un tonnage de sel sec supérieur à 30 tonnes ou une quantité de saumures supérieure à 8000 litres.",
        "no_fiche": "N° de fiche",
        "error": {
            "create": "Erreur lors de la création de la fiche de liaison. Veuillez vérifier le formulaire.",
            "update": "Erreur lors de la modification de la fiche de liaison. Veuillez vérifier le formulaire.",
        },
        "alerts": {
            "title": "Alertes",
            "see_all": "Tout voir",
            "true": "Alerte",
            "false": "Pas d'alerte",
        }
    },
    "link_row": {
        "roadway_state": "État de la chaussée",
        "snow_state": "État de la neige",
        "traffic_condition": "Conditions de conduite hivernale",
        "list": "Enregistrements",
        "details": "Détails de l'enregistrement",
        "add": "Ajout d'un enregistrement",
        "update": "Modification de l'enregistrement",
        "added": "L'enregistrement a été ajouté",
        "updated": "L'enregistrement a été modifié",
        "deleted": "L'enregistrement' a été supprimé",
        "delete_dialog": "Suppression de l'enregistrement",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer l'enregistrement ?",
    },
    "vh_type": {
        "highway": "VH Autoroutes",
        "national": "VH Nationales",
    },
    "link_night": {
        "day": "Journée",
        "night": "Nuit",
    },
    "link_type": {
        "start": "Début d'intervention",
        "intermediary": "Milieu d'intervention",
        "end": "Fin d'intervention",
    },
    "traffic_condition": {
        "C1": "C1",
        "C2": "C2",
        "C3": "C3",
        "C4": "C4",
    },
    "roadway_state": {
        "dry": "Sèche",
        "humid": "Humide",
        "wet": "Mouillée ",
        "dripping": "Ruisselante",
    },
    "snow_state": {
        "dry": "Sèche",
        "humid": "Humide",
        "wet": "Mouillée ",
    },
    "ager_role": {
        "direction": "Direction AGER",
        "cadre": "Cadre N1-AGER",
        "ugf": "UGF AGER",
        "bagr": "BAGR AGER",
    },
    "cei_role": {
        "direction": "Direction CEI",
        "ri": "R.I CEI",
    },
    "user_group": {
        "list": "Liste des groupes utilisateurs",
        "name": "Nom",
        "added": "Le groupe utilisateur a été ajouté",
        "updated": "Le groupe utilisateur a été modifié",
        "deleted": "Le groupe utilisateur a été supprimé",
        "create_dialog": "Création d'un groupe utilisateur",
        "edit_dialog": "Édition du groupe utilisateur",
        "delete_dialog": "Suppression du groupe utilisateur",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer le groupe utilisateur ?",
    },
    "classic_daily_summary": {
        "list": "Synthèses quotidiennes classiques",
        "title": "Synthèse quotidienne classique du {0}",
        "virtual_cei": "Afficher les CEI virtuels",
        "intervention_table": "Tableau de synthèse des interventions sur le réseau DiRIF",
        "localisation": "Localisation",
        "forecast": "Prévision",
        "link": "Liaison(s)",
        "intervention_types": "Types d'intervention",
        "intervention_features": "Caractéristiques d'intervention",
        "winter_driving_conditions": "Conditions de conduite hivernales",
        "forecast_sheet": "Fiche de prévision",
        "precurative_treatment": "Traitement préventif / pré-curatif",
        "curative_treatment": "Traitement curatif",
        "sore_points": "Points sensibles",
        "link_sheet_begin": "Fiche de liaison (début d'intervention)",
        "link_sheet_end": "Fiche de liaison (fin d'intervention)",
        "link_sheet_inter": "Fiche de liaison (intermédiaire)",
        "patrolling": "Patrouillage",
        "intervention_begin_intervention": "heure de début d’intevention",
        "intervention_end_intervention": "heure de fin d’intevention",
        "dry_salt": "Sel sec utilisé (T)",
        "brine": "Saumure utilisée (L)",
    },
    "modernized_daily_summary": {
        "list": "Synthèses quotidiennes modernisées",
        "title": "Synthèse quotidienne modernisée du {0}",
        "virtual_cei": "Afficher les CEI virtuels",
    },
    "weekly_summary": {
        "list": "Synthèses hebdomadaires",
        "title": "Synthèse hebdomadaire du {0} au {1} (semaine {2})",
        "virtual_cei": "Afficher les CEI virtuels",
    },
    "sheet": {
        "created_by": "Fiche créée par {0}",
        "validated_by": "Fiche validée par {0}",
    },
    "validation_status": {
        "validated": "Validée",
        "redaction": "En rédaction",
        "archived": "Archivée"
    },
    "bilan_cond_travail": {
        "list": "Bilan de l’organisation des conditions de travail des personnels",
        "synthese": "Bilan de l’organisation des conditions de travail des personnels",
        "week": "N° de semaine",
        "week_start": "N° de semaine (début)",
        "week_end": "N° de semaine (fin)",
        "title1": "Retour d'astreinte",
        "title2": "Dérogations aux garanties minimales",
        "title3": "Organisations spécifiques pour gérer les événements importants attendus",
        "taux_retour_astreinte": "Taux de retour sur astreinte (VH+accident)",
        "taux_retour_astreinte_detail": "Taux de retours sur astreinte = (Taux RI + Taux Agent)/2",
        "nb1": "Nombre de cas individuels où la durée de travail hebdomadaire a été supérieure à 60 h",
        "nb2": "Nombre de cas où pour une période de 12 semaines consécutives, la durée du travail hebdomadaire a été supérieure à 44 h en moyenne",
        "nb3": "Nombre de cas individuels de repos quotidien inférieur à 9 h",
        "nb4": "Nombre de cas individuels de repos quotidien inférieur à 7 h",
        "nb5": "Nombre de cas individuels de travail quotidien supérieur à 12 h",
        "nb6": "Nombre de cas individuels de travail quotidien supérieur à 15 h",
        "nb7": "Nombre de cas où le repos récupérateur de 11 h a été interrompu",
        "nb8": "Nombre de cas où le repos récupérateur de 35 h a été interrompu",
        "nb9": "Nombre de mises en repos récupérateur (11 et 35h)",
        "nb10": "Nombre d'occurrences (semaine-agent) de périodes de travail dépassant 7 jours de travail consécutifs",
        "nb11": "Nombre d'occurrences de mises en astreinte avec un préavis inférieur à 15 jours",
        "meo_action_renforcee": "Mise en œuvre de l'action renforcée",
        "meo_org_travail_spec": "Mise en œuvre d'organisations de travail spécifiques",
        "mep_prog_activite": "Mise en place d'une programmation de l'activité permettant un repos de 9h avant un événement significatif attendu la nuit suivante",
        "org_particuliere_av_we": "Organisation particulière avant un WE avec un événement significatif attendu Autres organisations mises en place",
        detail_calculs: {
            title: "Explication des calculs",
            taux_retour_astreinte_title: "Taux de retour sur astreinte (VH + accident) = (Taux RI + Taux Agent)/2",
            derogation_60h_title: "Nombre de cas individuels où la durée de travail hebdomadaire a été supérieure à 60 h",
            derogation_44h_title: "Nombre de cas où pour une période de 12 semaines consécutives, la durée du travail hebdomadaire a été supérieure à 44 h en moyenne",
            derogation_repos_quotidien_7h_title: "Nombre de cas individuels de repos quotidien inférieur à 7 h",
            derogation_repos_recuperateur_11h_title: "Nombre de cas où le repos récupérateur de 11 h a été interrompu",
            derogation_repos_recuperateur_35h_title: "Nombre de cas où le repos récupérateur de 35 h a été interrompu",
            repos_recuperateur_11h_title: "Repos récupérateur : 11 h",
            repos_recuperateur_35h_title: "Repos récupérateur : 35 h",
            derogation_title: "Dérégations aux garanties minimales",
            repos_recuperateur_11h_calcul1: "RI + Agent = Nombre de fois",
            repos_recuperateur_11h_calcul2: "Nombre de mises en repos récupérateur de 11h Total = (RI + Agent) x Nombre d'agents qui sont concernés",
            repos_recuperateur_35h_calcul1: "RI + Agent = Nombre de fois",
            repos_recuperateur_35h_calcul2: "Nombre de mises en repos récupérateur de 35h Total = (RI + Agent) x Nombre d'agents qui sont concernés",
            taux_retour_astreinte_calcul1: "RI-VH",
            taux_retour_astreinte_calcul2: "Taux Agent",
            taux_retour_astreinte_calcul_explication_detail: "RI-VH, Taux RI = Nombre total de RI / (RI ACC + RI VH)<br/>Taux Agent = Nombre total d'agents / (Agents ACC + Agents VH)",
            taux_retour_astreinte_calcul1_explication: "Taux RI = Nombre total de RI / (RI ACC + RI VH)",
            taux_retour_astreinte_calcul2_explication: "Taux Agent = Nombre total d'agents / (Agents ACC + Agents VH)",
            derogation_60h_explication: "Nombre d’occurrences de dépassement des 60h",
            derogation_44h_explication: "Nombre d’occurrences de dépassement des 44h en moyenne sur 12 semaines",
            derogation_repos_quotidien_7h_explication: "Nombre d’occurrences où le repos quotidien est inférieur à 7h ce qui donne droit à un repos récupérateur de 11h",
            derogation_repos_recuperateur_11h_explication: "Nombre de cas où un agent placé en repos récupérateur de 11h a été rappelé",
            derogation_repos_recuperateur_35h_explication: "Nombre de cas où un agent placé en repos récupérateur de 35h a été rappelé",
            repos_recuperateur_11h_35h_calcul_explication_detail: "pour les cas de mise en repos récupérateur de 11h : 11h = Nombre de fois où 11h ont été accordées en action corrective (travail de nuit >= 4h ou repos < 7h)<br><ul><li>RI + Agent = Nombre de fois</li><li>Nombre de mises en repos récupérateur de 11h Total = (RI + Agent) x Nombre d'agents qui sont concernés</li></ul><br>pour les cas de mise en repos récupérateur de 35h : 35h = On note les occurences de mise en repos récupérateur en cas d'intervention toute la semaine (cas où l'agent n'a pas eu 24h de repos)<br><ul><li>RI + Agent = Nombre de fois</li><li>Nombre de mises en repos récupérateur de 35h Total = (RI + Agent) x Nombre d'agents qui sont concernés</li></ul>",
            repos_recuperateur_11h_calcul_explication: "11h = Nombre de fois où 11h ont été accordées en action corrective (travail de nuit >= 4h ou repos < 7h)",
            repos_recuperateur_35h_calcul_explication: "35h = On note les occurences de mise en repos récupérateur en cas d'intervention toute la semaine (cas où l'agent n'a pas eu 24h de repos)",
        }
    },
    "bilan_crise": {
        "author": "Auteur",
        "list": "Bilan des périodes de gestion de crise",
        "synthese": "Bilan des périodes de gestion de crise",
        "name": "Nom",
        "input_text_area_title": "Problème et solution",
        "date_start": "Date de début",
        "date_end": "Date de fin",
        "period": "Période de crise",
        "add_crise": "Ajouter une crise",
        "add_crise_period": "Ajouter une période de crise",
        "issue": "Problème rencontré",
        "solution": "Solution trouvée",
        "create": "Création d'une crise",
        "period_create": "Création d'une période de crise",
        "created": "La crise a été créée",
        "period_created": "La période de crise a été créée",
        "details": "Détails de la crise",
        "period_details": "Détails de la période de crise",
        "update": "Modification de la crise",
        "period_update": "Modification de la période de crise",
        "updated": "La crise a été modifiée",
        "period_updated": "La période de crise a été modifiée",
        "deleted": "La crise a été supprimée",
        "period_deleted": "La période de crise a été supprimée",
        "period_delete_error": "Une période de crise ne peut être supprimée que si il n'y a aucune crise liée à celle-ci",
        "period_title": "Période du {0} au {1}",
        "problem_not_found": "Problème non renseigné",
        "solution_not_found": "Solution non renseignée",
        "problem_description": "Problème : ",
        "solution_description": "Solution : ",
        "delete_crisis_dialog": "Suppression de la crise",
        "confirm_delete_crisis": "Êtes-vous sûr de vouloir supprimer cette crise ?",
        "delete_period_dialog": "Suppression de la période de crise",
        "confirm_delete_period": "Êtes-vous sûr de vouloir supprimer cette période de crise ?",
    },
    "bilan_formation": {
        "title1": "GPS",
        "title2": "PEVH",
        "title3": "Formation des agents au matériel VH",
        "title4": "Formation des agents aux circuits VH",
        "title5": "Formation RIVH",
        "list": "Bilan des formations",
        "synthese": "Bilan des formations",
        "gps_diff": "Mode de diffusion de la note sur les GPS",
        "gps_form": "Mode de formation des agents au GPS",
        "pevh_date_parution": "Date de parution",
        "pevh_date_validation": "Date de validation",
        "pevh_mode_diffusion": "Mode de diffusion",
        "materiel_forme": "Forme de la formation",
        "materiel_commentaire": "Commentaires",
        "circuit_forme": "Forme de la formation",
        "circuit_commentaire": "Commentaires",
        "rivh_nb": "Nombre d’agents formés",
        "rivh_commentaire": "Commentaires",
    },
    "bilan_circuit": {
        "list": "Bilan des circuits",
        "synthese": "Bilan des circuits",
        "added": "Le bilan a été ajouté",
        "updated": "Le bilan a été modifié",
        "deleted": "Le bilan a été supprimé",
        "week": "N° de semaine",
        "circuit": "Circuit",
        "sections": "Sections",
        "axes": "Axes",
        "section": "Section",
        "axe": "Axe",
        "nb_conduite": "Conduite à 1 ou conduite à 2",
        "lineaire_total": "Linéaire total du circuit (m)",
        "lineaire_salage": "Linéaire salage (m)",
        "surface_salage": "Surface salage (m²)",
        "duree_estime_traitement": "Durée estimée du traitement en heures",
        "duree_estime_parcours": "Durée estimée du parcours en heures",
        "tonnage_estime_sel": "Tonnage estimé de sel utilisé en précuratif à 15 g",
        "capacite_saleuse": "Capacité saleuse utilisée (m³)",
        "nb_inter_precur": "Nombre total d'interventions précuratives",
        "nb_inter_cur": "Nombre total d'interventions curatives",
        "nb_inter_pts_sensible": "Nombre total d'interventions points sensibles",
        "ton_dry_salt_used": "Sel sec utilisé (T)",
        "litre_brine_used": "Saumure utilisée (L)",
        "nb_circuits": "Nombre de circuits",
    },
    "bilan_materiel": {
        "list": "Bilan des matériels",
        "synthese": "Bilan des matériels",
        "added": "Le bilan a été ajouté",
        "updated": "Le bilan a été modifié",
        "deleted": "Le bilan a été supprimé",
        "week": "N° de semaine",
        "circuit": "Circuits (ou numéro de mulet)",
        "sections": "Sections",
        "axes": "Axes",
        "section": "Section",
        "axe": "Axe",
        "truck_type": "Type du camion (16 T, 19 T, 26 T)",
        "brand": "Marque",
        "rent": "Location",
        "salt_unit_brine": "Unités de salage (avec et sans saumure)",
        "salt_unit": "Unités de salage",
        "brine": "Saumure",
        "with": "Avec",
        "without": "Sans",
        "nb_repair_materiel_vh": "Nombre de réparations effectuées sur matériel VH",
        "problem_met_and_suggestions": "Problèmes spécifiques rencontrés et suggestions",
        "v3m3": "3 m³",
        "v4a45m3": "4 et 4,5 m³",
        "v5m3": "5 m³",
        "v6m3": "6 m³",
        "v7a8m3": "7 et 8 m³",
        "nb_circuits": "Nombre de circuits",
        "mule": "Mulet",
        "ager_mule": "Mulets de l'AGER {0}",
        "new_mule": "Nouveau mulet",
        "mule_number": "Numéro de mulet",
        "total": "Total AGER {0}",
        "truck_info": "Caractéristiques du camion",
        "salting": "Unités de salage",
        "repairs_and_problems": "Remarques"
    },
    "bilan": {
        "author": "Auteur",
        "delete_dialog": "Suppression du bilan",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer ce bilan ?",
        "details": "Détail d'un bilan",
        "create": "Création d'un bilan",
        "update": "Modification d'un bilan",
        "added": "Le bilan a été ajouté",
        "updated": "Le bilan a été modifié",
        "deleted": "Le bilan a été supprimé",
        "error": {
            "create": "Erreur lors de la création du bilan. Veuillez vérifier le formulaire.",
            "update": "Erreur lors de la modification du bilan. Veuillez vérifier le formulaire.",
            "weeks": "Les numéros de semaine sont incorrects",
            "dates": "Les dates sont incorrectes",
            "no_circuits_cei": "Aucun circuit n'a été renseigné pour ce CEI",
        },
    },
    "ceiAgent": {
        "cei": "CEI",
        "list": "Liste des agents",
        "update_dialog": "Modification d'un agent",
        "create_dialog": "Création d'un agent",
        "delete_dialog": "Suppression d'un agent",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer l'agent",
    },
    "form": {
        "row_copied": "Données copiées",
        "row_pasted": "Données collées",
        "no_row_copied": "Veuillez d'abord copier des données",
    },
    "axeintervention": {
        "list": "Liste des axes d'intervention",
        "added": "L'axe d'intervention a été ajouté",
        "updated": "L'axe d'intervention a été modifié",
        "deleted": "L'axe d'intervention a été supprimé",
        "libelle": "Libellé",
        "create_dialog": "Création d'un axe d'intervention",
        "edit_dialog": "Modification d'un axe d'intervention",
        "name": "Axe d'intervention",
        "names": "Axes d'interventions",
        "delete_dialog": "Suppression d'un axe d'intervention",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer cet axe d'intervention ?",
        "autoroute": "Autoroute",
        tech_type_axe: "Type d'axe",
    },
    "intervention": {
        "created": "L'intervention a été créée",
        "createdAndValidated": "L'intervention a été créée et validée",
        "no_intervention_cei": "N° Inter CEI",
        "no_intervention_dirif": "N° Inter DiRIF",
        "periodStart": "Période du",
        "periodEnd": "Au",
        "title": "Fiches des interventions",
        "add_intervention": "Ajouter une intervention",
        "autre_agent": "Autre agent",
        "details": "Détails d'une intervention",
        "update": "Modification d'une intervention",
        "deleted": "L'intervention a été supprimée",
        "deleted_failed": "Erreur lors de la suppression de l'intervention",
        "validated": "L'intervention a été validée",
        "validated_failed": "Erreur lors de la validation de l'intervention",
        "create": "Création d'une intervention",
        "ager": "AGER",
        "uer": "UER",
        "cei": "CEI",
        "call_date_hour": "Date/Heure d'appel",
        "call_date_hour_required": "Date*/Heure d'appel*",
        "call_date": "Date",
        "call_hour": "Heure",
        "call_origin": "Origine de l'appel",
        "other_call_origin": "Autre origine de l'appel",
        "axe_sens": "Axe/Sens",
        "ri": "R.I.",
        "axe": "Axe",
        "sens": "Sens",
        "voie": "Voie",
        "pr_voie": "PR/Voie",
        "pr": "PR",
        "agents": "Agents",
        "status": "Statut",
        "update_observation": "Modification de l'observation",
        "coordonnees": "Créateur de la fiche",
        "author": "Auteur",
        "error_heure_debut_fin": "L'heure de fin doit être supérieure à l'heure de début",
        "error_heure_appel_fin": "L'heure de fin doit être supérieure à l'heure d'appel",
        "error_heure_arrivee_depart": "L'heure de départ doit être supérieure à l'heure d'arrivée",
        "error_heure_debut_arrivee": "L'heure d'arrivée doit être supérieure à l'heure de début",
        "error_heure_depart_fin": "L'heure de fin doit être supérieure à l'heure de départ",
        "commune": "Commune",
        "horaire_arrivee_site": "Horaire d'arrivée sur le lieu d'intervention",
        "horaire_depart_site": "Horaire de départ du lieu d'intervention",
        "heure_debut_fin": "Heure de début/fin",
        "heure_debut_fin_required": "Heure de début*/fin*",
        "heure_debut": "Heure de début",
        "heure_fin": "Heure de fin",
        "heure_arrivee_depart": "Heure d'arrivée/départ du lieu d'intervention",
        "heure_arrivee_depart_required": "Heure d'arrivée*/départ du lieu d'intervention*",
        "heure_arrivee": "Arrivée",
        "heure_depart": "Départ",
        "observation": "Observations",
        "presence_chef_equipe": "Présence du chef d'équipe",
        "presence_ri": "Présence du RI",
        "lieu_intervention": "Lieu d'intervention",
        "environnement": "Environnement",
        "type_intervention": "Type d'intervention",
        "other_type_intervention": "Autre type d'intervention",
        "precision_niveau_1": "Précision niveau 1",
        "precision_niveau_2": "Précision niveau 2",
        "intervention": "Intervention",
        "moyens_utilises": "Moyens utilisés pour l'intervention",
        "moyens_humains": "Moyens humains",
        "moyens_materiels": "Moyens matériels",
        "etat_chaussee": "Etat de la chaussée",
        "conditions_meteo": "Conditions météorologiques",
        "vehicules_impliques": "Véhicules impliqués",
        "save_intervention": "Enregistrer l'intervention",
        "validate": "Valider",
        "validate_intervention": "Valider l'intervention",
        "circonstances_connues": "Circonstances connues",
        "edit_dialog": "Modification d'une intervention",
        "edit_validate_dialog": "Validation d'une intervention",
        "confirm_update": "Êtes-vous sûr de vouloir modifier cette intervention ?",
        "confirm_validate": "Êtes-vous sûr de vouloir valider cette intervention ? Vous ne pourrez plus modifier les informations saisies.",
        "confirm_update_validate": "Êtes-vous sûr de vouloir modifier et valider cette intervention ? Vous ne pourrez plus modifier les informations saisies.",
        "confirm_create": "Êtes-vous sûr de vouloir créer cette intervention ?",
        "confirm_create_validate": "Êtes-vous sûr de vouloir créer et valider cette intervention ? Vous ne pourrez plus modifier les informations saisies.",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer cette intervention ?",
        "files": "Fichiers",
        "update_this": "Modifier l'intervention",
        "updated": "L'intervention a été modifiée",
        "display_user_intervention": "Afficher les interventions de l'utilisateur",
        "display_all_intervention": "Afficher toutes les interventions",
        "nb_item_prefix_label": "Nombre de",
        "pr_format_tooltip": "Chiffres et point autorisés uniquement (Exemple : 10.600)",
        "delete_dialog": "Suppression d'une intervention",
        "delete_selected_interventions": "Supprimer les interventions sélectionnées",
        "interventions_deleted": "Les interventions ont été supprimées",
        "interventions_not_deleted": "Erreur lors de la suppression des interventions",
        "no_intervention_selected": "Aucune intervention sélectionnée",
        "settings_dialog": "Paramètres d'exports des interventions",
        "table_settings_dialog": "Paramètres d'affichage de la liste d'interventions",
        "update_settings": "Vous allez changer vos paramètres d'exports des interventions",
        "update_table_settings": "Vous allez changer vos paramètres d'affichage de la liste d'interventions",
        "numero": "N°",
        "noAutoroute": "N° Autoroute",
        "help_dialog": "Aide sur les interventions",
        "help_dialog_header": "Vous trouverez ici des informations sur les options de paramétrage de la liste d'interventions et des exports",
        "help_dialog_content": "Vous pouvez personnaliser les colonnes affichées dans la liste d'interventions en cochant les cases correspondantes.<br><br>Vous pouvez également choisir les colonnes à exporter en cochant les cases correspondantes proposées par le bouton 'Paramètres d'affichage de la liste d'interventions'.<br><br>Vous pouvez paramétrer les colonnes exportées avec le bouton 'Télécharger fiches personnalisées' en cliquant sur le bouton 'Personnaliser export fiches'.<br><br>Les exports prennent en compte les filtres actuellement appliqués. Vous pouvez les réinitialiser avec le bouton 'Réinitialiser les filtres'.",
        type_axe: "Type d'axe",
        no_echangeur: "N° ou Nom de l'échangeur",
        no_bretelle: "N° ou Nom de la bretelle",
        type_echangeur: "Type d'échangeur",
        direction: "Bretelle en direction de",
        nom_lieu: "Nom/Lieu",
        old_data: "Cette intervention a été créée avant la mise en place de la nouvelle version de l'application. Certaines informations peuvent avoir été mises à jour.",
    },
    "intervention_list": {
        download: "Téléchargement des fiches",
        "download_excel_full": "Télécharger fiches complètes",
        "download_excel": "Télécharger fiches simplifiées",
        "download_custom_excel": "Télécharger fiches personnalisées",
        "settings_custom_excel": "Personnaliser export fiches",
        "reset_custom_filter": "Réinitialiser",
        "add_full_intervention": "Ajouter Fiche complète intervention",
        "add_light_intervention": "Ajouter Fiche simplifiée",
        "settings_intervention_table": "Paramètres d'affichage de la liste d'interventions",
        settings_intervention: "Paramètres des interventions",
        "tick_all": "Tout cocher",
        "untick_all": "Tout décocher",
    },
    "sens": {
        "w": "W",
        "y": "Y",
        "int": "INT",
        "ext": "EXT",
    },
    "voie": {
        "bau": "BAU",
        "voie_lente": "Voie lente",
        "voie_rapide": "Voie rapide",
        "voie_mediane": "Voie(s) médiane(s)",
        "tpc": "TPC",
        "accotement": "Accotement",
    },
    "origine_appel": {
        "ost": "OST",
        "police": "Police",
        "gendarmerie": "Gendarmerie",
        "pompiers": "Pompiers",
        "depanneurs": "Dépanneurs",
        "autres_gestionnaires_reseau": "Autres gestionnaires de réseau",
        "usagers": "Usagers",
        "ri": "RI",
        "autre": "Autre",
    },
    "type_intervention": {
        "accident": "Accident",
        "animaux": "Animaux",
        "bouchon": "Bouchon",
        "intemperie": "Intempérie",
        "obstacle_mobile_fixe": "Obstacle mobile/fixe",
        "vehicule_en_panne": "Véhicule en panne",
        "balisage": "Balisage",
        "chaussee": "Chaussée",
        "autre": "Autre",
    },
    "moyens_humains": {
        "chef_equipe": "RI",
        "agent_exploitation": "Agent d'exploitation",
    },
    "moyens_materiels": {
        "vl": "VL",
        "vul": "VUL",
        "fourgons": "Fourgons",
        "trafic_partner": "Trafic/Partner",
        "flr": "FLR",
        "sac_seau_absorbant": "Sac ou seau d'absorbant",
    },
    "etat_chaussee": {
        "seche": "Sèche",
        "humide": "Humide",
        "mouillee": "Mouillée",
        "ruisselante": "Ruisselante",
        "verglacee": "Verglacée",
        "enneigee": "Enneigée",
    },
    "condition_meteo": {
        "ras": "R.A.S",
        "pluie": "Pluie",
        "neige": "Neige",
        "brouillard": "Brouillard",
    },
    "precisions": {
        "1": {
            "accident": {
                "materiel": "Matériel",
                "corporel": "Corporel",
                "mortel": "Mortel",
            },
            "animaux": {
                "animal_errant": "Animal errant",
                "animal_mort": "Animal mort",
            },
            "bouchon": {
                "ralentissement": "Ralentissement",
                "circulation_accordeon": "Circulation en accordéon",
                "circulation_arretee": "Circulation arrêtée",
            },
            "intemperie": {
                "vent_violent": "Vent violent",
                "pluie_violente": "Pluie violente",
                "chutes_de_neige_violentes": "Chutes de neige violentes",
                "inondation": "Inondation",
                "incendie": "Incendie",
            },
            "obstacle_mobile_fixe": {
                "chaussee_glissante_produits_route": "Chaussée glissante et produits sur la route",
                "evenements_inopines": "Événements inopinés",
                "obstacles": "Obstacles",
                "pieton_cycliste": "Piéton/cycliste",
                "vehicule_genant": "Véhicule gênant",
                "vehicule_contresens": "Véhicule en contresens",
                "vehicule_arrete": "Véhicule arrêté",
            },
            "balisage": {
                "introduction_vehicule_balisage": "Introduction d'un véhicule dans le balisage",
                "autres": "Autres",
            },
            "chaussee": {
                "rebouchage_nid_poule": "Rebouchage d'un nid de poule",
                "epandage_absorbant_chaussee": "Épandage d'absorbant sur la chaussée",
                "autres": "Autres",
            },
        },
        "2": {
            "animaux": {
                "sauvage": "Sauvage",
                "domestique": "Domestique",
                "elevage": "Élevage",
            },
            "chaussee_glissante_produits_route": {
                "eau": "Eau",
                "hydrocarbures": "Hydrocarbures",
                "produits_chimiques_toxiques": "Produits chimiques toxiques",
                "graviers": "Graviers",
                "boue": "Boue",
            },
            "evenements_inopines": {
                "inondation": "Inondation",
                "eboulement": "Éboulement",
                "manifestation": "Manifestation",
                "autres": "Autres",
            },
            "obstacles": {
                "objets": "Objets",
                "cones": "Cones",
                "autres": "Autres",
            },
            "pieton_cycliste": {
                "pieton": "Piéton",
                "cycliste": "Cycliste",
                "trotinette": "Trotinette",
                "autres": "Autres",
            },
            "vehicule_genant": {
                "vehicule_en_difficulte": "Véhicule en difficulté",
                "vehicule_non_autorise": "Véhicule non autorisé",
                "autres": "Autres",
            },
            "vehicule_arrete": {
                "vehicule_arrete": "Véhicule arrêté",
                "vehicule_abandonne": "Véhicule abandonné",
                "vehicule_en_feu": "Véhicule en feu",
            }
        }
    },
    "vehicules_impliques": {
        "title": "Véhicules impliqués",
        "genre": "Genre",
        "marque": "Marque",
        "immatriculation": "Immatriculation",
        "degats_materiels": "Dégâts matériels",
        "dommages_corporels": "Dommages corporels",
        "responsable_ddp": "Responsable DDP",
        "ajouter_vehicule": "Ajouter un véhicule",
        "delete_dialog": "Suppression d'un véhicule",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer ce véhicule ?",
        "vl": "VL",
        "fourgon": "Fourgon",
        "pl": "PL",
        "moto_scooter": "Moto/Scooter",
        "velo": "Vélo",
        "trotinette": "Trotinette",
        "genre_empty_error": "Le genre d'un véhicule est obligatoire",
        "autre_vehicule": "Autre véhicule",
        "type_vehicule_empty_error": "Le type d'un véhicule est obligatoire si le genre est 'Autre véhicule'",
    },
    "ddp": {
        "title": "Dégâts au domaine public",
        "title_short": "DDP",
        "presence_tiers_responsable": "Présence du tiers à l'origine des DDP sur les lieux",
        "nature_degats": "Nature des dégâts",
        "other_nature": "Préciser les dégâts si besoin",
        "unite": "Unité",
        "quantite": "Quantité",
        "ajouter_ddp": "Ajouter un DDP",
        "delete_dialog": "Suppression d'un DDP",
        "observations": "Observations liées au DDP",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer ce DDP ?",
        "empty_field_error": "Tous les champs d'un DDP sont obligatoires",
    },
    "nature_degats": {
        "glissieres": "Glissières",
        "portique": "Portique",
        "enrobe": "Enrobé",
        "signalisation_verticale": "Signalisation verticale",
        "autres": "Autres",
    },
    "genre_vehicule": {
        "vl": "VL",
        "fourgon": "Fourgon",
        "pl": "PL",
        "moto_scooter": "Moto/Scooter",
        "velo": "Vélo",
        "trotinette": "Trotinette",
        "autre_vehicule": "Autre véhicule",
    },
    "intervenant": {
        "title": "Intervenants",
        "police": "Police",
        "pompiers": "Pompiers",
        "gendarmerie": "Gendarmerie",
        "depanneurs": "Dépanneurs",
        "samu_smur": "SAMU/SMUR",
        "autres": "Autres",
    },
    "action": {
        "title": "Actions réalisées",
        "balisage": "Balisage",
        "neutralisation_voie_lente": "Neutralisation de voie lente",
        "neutralisation_voie_mediane": "Neutralisation de voie médiane",
        "neutralisation_voie_rapide": "Neutralisation de voie rapide",
        "fermeture_axe": "Fermeture d'axe",
        "deviation": "Déviation",
        "nettoyage_balayage_ramassage": "Nettoyage/Balayage/Ramassage",
        "protection": "Protection",
        "fermeture_bretelle": "Fermeture de bretelle",
        "autre": "Autre",
    },
    "userSettings": {
        "interventions": {
            "noInterDirif": "N° Inter DiRIF",
            "noInterCei": "N° Inter CEI",
            "ager": "AGER",
            "uer": "UER",
            "cei": "CEI",
            "auteur": "Auteur",
            "callDate": "Date d'appel",
            "callTime": "Heure d'appel",
            "callOrigin": "Origine de l'appel",
            "axe": "Axe",
            "voie": "Voie",
            "sens": "Sens",
            "localisation": "Localisation",
            "heureDebut": "Heure de début",
            "heureFin": "Heure de fin",
            "typeIntervention": "Type d'intervention",
            "precisionNiveau1": "Précision niveau 1",
            "precisionNiveau2": "Précision niveau 2",
            "observation": "Observations",
            "presenceRi": "Présence du RI",
            "ddp": "DDP",
            "commune": "Commune",
            "heureArriveeSite": "Horaire d'arrivée sur le lieu d'intervention",
            "heureDepartSite": "Horaire de départ du lieu d'intervention",
            "moyensHumains": "Moyens humains",
            "moyensMateriels": "Moyens matériels",
            "etatChaussee": "État de la chaussée",
            "conditionsMeteo": "Conditions météorologiques",
            "intervenants": "Intervenants",
            "circonstances": "Circonstances",
            "actionsRealisees": "Actions réalisées",
            "vehiculesImpliques": "Véhicules impliqués",
            "agents": "Agents",
            "presenceTiersResponsable": "Présence du tiers à l'origine des DDP sur les lieux",
            "noBretelle": "N° Bretelle",
            "noAutoroute": "N° Autoroute",
            incivilite_agression: "Incivilités et agressions",
            typeAxe: "Type d'axe",
            typeEchangeur: "Type d'échangeur",
            no_echangeur: "N° ou Nom de l'échangeur",
            no_bretelle: "N° ou Nom de la bretelle",
            direction: "Bretelle en direction de",
            nomLieu: "Nom/Lieu",
            numero: "Numéro",
            dateValidated: "Date de validation",
        },
        "linkSheet": {
            "id": "Identifiant",
            "year": "Année",
            "moment": "Moment",
            "date": "Date",
            "typeDisplay": "Type",
            "ager": "AGER",
            "uer": "UER",
            "cei": "CEI",
            "dateCreated": "Date de création",
            "auteur": "Auteur",
            "dateValidated": "Date de validation",
            "typeFiche": "Type de fiche",
            "typeVH": "Type VH",
            "circuit": "Circuit",
            "roadwayState": "État de la chaussée",
            "snowState": "État de la neige",
            "airTemp": "Température de l'air (°C)",
            "groundTemp": "Température du sol (°C)",
            "humidity": "Humidité relative (%)",
            "freezingHumidity": "Congélation d'humidité préexistante",
            "groundFrost": "Gelée blanche",
            "freezingFog": "Brouillard givrant",
            "rainOnFrozenGround": "Pluie sur sol gelé",
            "rainOnSurfusion": "Pluie en surfusion",
            "obs1": "Observations 1",
            "alertHour": "Heure d'alerte",
            "startHour": "Heure de début",
            "endHour": "Heure de fin",
            "agentNumber": "Nombre d'agent dans l'équipe d'intervention",
            "drySaltTonnage": "Tonnage de sel sec",
            "brineLiters": "Litres de saumure",
            "patrol": "Patrouille",
            "precurative": "Précuratif",
            "curative": "Curatif",
            "scraping": "Raclage",
            "singularPoint": "Point singulier",
            "obs2": "Observations 2",
            "trafficCondition": "Conditions de conduite hivernale",
            "obs3": "Observations 3",
        },
        "forecastSheet": {
            "id": "Identifiant",
            "year": "Année",
            "moment": "Moment",
            "date": "Date",
            "typeDisplay": "Type",
            "ager": "AGER",
            "uer": "UER",
            "cei": "CEI",
            "dateCreated": "Date de création",
            "auteur": "Auteur",
            "dateValidated": "Date de validation",
            "observations": "Observations",
            "heureDebutPatrouille": "Heure de début de patrouille",
            "heureDebutPrecuratif": "Heure de début de précuratif",
            "heureDebutCuratif": "Heure de début de curatif",
            "commentaireValidation": "Commentaire de validation",
            "precisionsComplementaires": "Précisions complémentaires",
            "averageAirTemp": "Température de l'air moyenne (°C)",
            "averageGroundTemp": "Température du sol moyenne (°C)",
            "averageHumidity": "Humidité relative moyenne (%)",
        }
    },
    "tableSettings": {
        interventions: {
            localisation: "Localisation",
            callDate: "Date/Heure d'appel",
            callOrigin: "Origine de l'appel",
            axeSensIntervention: "Axe/Sens",
            observation: "Observations",
            ager: "AGER",
            uer: "UER",
            cei: "CEI",
            ri: "RI",
            ddp: "DDP",
            heureArriveeDepart: "Heure d'arrivée/départ",
            typeIntervention: "Type d'intervention",
            author: "Auteur",
            noInterventionCei: "N° Inter CEI",
            noInterventionDirif: "N° Inter DiRIF",
            heureDebutFin: "Heure de début/fin",
        }
    },
    "ged": {
        title: "Documents",
        error_loading: "Erreur lors du chargement des documents",
        add_document: "Ajout d'un document",
        update_document: "Modification d'un document",
        delete_document: "Suppression d'un document",
        delete_documents: "Suppression des documents sélectionnés",
        move_documents: "Déplacement des documents sélectionnés",
        folder: "Dossier",
        fic: "Fichier",
        folder_name: "Nom du dossier",
        fic_name: "Nom du fichier",
        fic_file: "Fichier",
        parent_folder: "Dossier parent",
        root_folder: "Dossier racine",
        document_type: "Type de document",
        date_created: "Création",
        doc_name: "Nom",
        delete_document_confirm: "Êtes-vous sûr de vouloir supprimer le document ",
        delete_documents_confirm: "Êtes-vous sûr de vouloir supprimer les documents sélectionnés ?",
        move_documents_confirm: "Veuillez sélectionner un dossier de destination pour les documents sélectionnés",
        destination_folder: "Dossier de destination",
        shared: "Partagé",
        error_missing_files: "Veuillez sélectionner un fichier pour ajouter un document de type fichier",
        error_missing_name: "Veuillez donner un nom au fichier ou dossier à modifier",
        error_missing_newParentId: "Veuillez sélectionner un dossier de destination",
        author: "Auteur",
        search: "Recherche",
        ged: "Bibliothèque",
        link_copied: "Lien copié",
        link_copy_error: "Erreur lors de la copie du lien",
        fic_created: "Le fichier a été créé",
        error_created: "Erreur lors de la création",
        folder_created: "Le dossier a été créé",
        fic_updated: "Le fichier a été modifié",
        folder_updated: "Le dossier a été modifié",
        error_updated: "Erreur lors de la modification",
        fic_deleted: "Le fichier a été supprimé",
        folder_deleted: "Le dossier a été supprimé",
        error_deleted: "Erreur lors de la suppression",
        moved_multiple: "Les documents ont été déplacés",
        error_moved_multiple: "Erreur lors du déplacement des documents",
        deleted_multiple: "Les documents ont été supprimés",
        error_deleted_multiple: "Erreur lors de la suppression des documents",
        search_list_empty: "Aucun document ne correspond à votre recherche ou votre recherche est vide",
        change_fic_file: "Remplacer le fichier",
        file_error_multiple: "Il ne faut sélectionner qu'un seul fichier pour remplacer le fichier actuel",
    },
    "epiFournisseur": {
        "enabled": "Actif",
        "relance": "Relance à J-3",
        "nom": "Nom",
        "code": "Code fournisseur",
        "adresse": "Adresse",
        "adresseComplement": "Complement d'adresse",
        "codePostal": "Code postal",
        "ville": "Ville",
        "pays": "Pays",
        "email": "Email",
        "tel": "Téléphone",
        "delaiLivraison": "Délai de livraison (jours)",
        "codeMarche": "Code marché",
        "objetDeMarche": "Objet de marché",
        "contact": "Contact",
        "title": "Fournisseurs",
        "list": "Liste des fournisseurs",
        "added": "Le fournisseur a été ajouté",
        "updated": "Le fournisseur a été modifié",
        "deleted": "Le fournisseur a été supprimé",
        "create_dialog": "Création d'un fournisseur",
        "edit_dialog": "Édition du fournisseur",
        "delete_dialog": "Suppression du fournisseur",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer le fournisseur ?",
    },
    "epiActivite": {
        "enabled": "Actif",
        "nom": "Nom",
        "code": "Code",
        "title": "Activités des agents",
        "list": "Liste des activités des agents",
        "added": "L'activité a été ajoutée",
        "updated": "L'activité a été modifiée",
        "deleted": "L'activité a été supprimée",
        "create_dialog": "Création d'une activité",
        "edit_dialog": "Édition de l'activité",
        "delete_dialog": "Suppression de l'activité",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer l'activité ?",
    },
    "epiTaille": {
        "libelle": "Libellé",
        "libelle_many": "Séquences de libellés (Exemple: M;L;XL)",
        "rubrique": "Rubrique",
        "ordre": "Ordre",
        "title": "Tailles",
        "list": "Liste des tailles",
        "added": "La taille a été ajoutée",
        "updated": "La taille a été modifiée",
        "deleted": "La taille a été supprimée",
        "create_dialog": "Création d'une taille",
        "edit_dialog": "Édition de la taille",
        "delete_dialog": "Suppression de la taille",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer la taille ?",
    },
    "epiArticle": {
        "enabled": "Actif",
        "designation": "Désignation",
        "dateCreated": "Date de création",
        "rubrique": "Rubrique",
        "refDirif": "Référence DiRIF",
        "refFournisseur": "Référence fournisseur",
        "fournisseur": "Fournisseur",
        "descriptif": "Descriptif",
        "prixHt": "Prix HT",
        "tva": "TVA",
        "prixTtc": "Prix TTC",
        "photo": "Photo",
        "photos": "Photos",
        "title": "Articles",
        "list": "Liste des articles",
        "added": "L'article a été ajouté",
        "updated": "L'article a été modifié",
        "deleted": "L'article a été supprimé",
        "create_dialog": "Création d'un article",
        "edit_dialog": "Édition de l'article",
        "delete_dialog": "Suppression de l'article",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer l'article ?",
        quantiteStock: "Quantité en stock",
    },
    "epiDemande": {
        referents: "Référents EPI",
        synthese: "Synthèse des demandes",
        detail: "Détail de la demande",
        "numero": "Numéro de demande",
        "commentaire": "Commentaire",
        accept: "Demande acceptée",
        "etat": "Etat",
        "status": "Statut",
        "statusRetour": "Statut du retour",
        "articleNb": "Articles",
        "agentNb": "Agents",
        "quantiteTotal": "Nb total",
        "quantiteRestante": "En attente",
        "quantiteARetirer": "A retirer",
        "quantiteRetire": "Retiré",
        "quantiteDisponible": "Quantité disponible",
        "prixTotalHt": "Prix total HT",
        "validators": "Valideurs",
        "title": "Demandes EPI",
        demande: "Demande",
        "list": "Liste des demandes",
        "added": "La demande a été ajoutée",
        "updated": "La demande a été modifiée",
        "deleted": "La demande a été supprimée",
        "create_dialog": "Création d'une demande",
        "edit_dialog": "Édition de la demande",
        "delete_dialog": "Suppression de la demande",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer la demande ?",
        "create_demande": "Créer une demande",
        "disabledMessage": "Vous ne pouvez pas créer de nouvelle demande tant que votre retour actuel n'est pas validé",
        "continue_demande": "Reprendre le panier",
        "new_demande": "Nouvelle demande",
        select_agent: "Sélection d'un agent",
        agent: "Agent",
        catalogue: "Catalogue",
        articles: "Articles",
        add_article_dialog: "Ajouter au panier",
        article_removed: "Article retiré du panier",
        taille: "Taille",
        quantite: "Quantité demandée",
        cancel: "Abandonner",
        nom_agent: "Nom de l'agent",
        service_agent: "Service de l'agent",
        service: "Service",
        intitule_poste: "Poste",
        notifications_agents: "Notifier le(s) agent(s) par e-mail",
        code_dotation: "Code dotation",
        demande_validated: "La demande a été validée",
        demande_canceled: "La demande a été annulée",
        error_empty_cart_confirm: "Le panier est vide, impossible d'envoyer la demande",
        error_empty_cart_cancel: "Il n'y a pas de demande en cours",
        dateCreated: "Date de création",
        date_solde: "Date de clôture",
        comment_solde: "Commentaire de clôture",
        validate: "Valider",
        validation: "Validation",
        perimetre: "Périmètre",
        date_refus: "Date de refus",
        confirmation: "Confirmation",
        confirm: "Confirmer",
        validation_message: "Vous êtes sur le point de valider la demande. Êtes-vous sûr de vouloir continuer ?",
        duplicate: "Dupliquer",
        duplication: "Duplication",
        duplication_message: "Vous êtes sur le point de dupliquer la demande. Êtes-vous sûr de vouloir continuer ?",
        duplication_message_panier_present: "Vous avez déjà un panier en cours, il sera écrasé. Êtes-vous sûr de vouloir continuer ?",
        creator: "Créateur",
        validator: "Valideur",
        validation_comment: "Commentaire de validation",
        history: "Historique",
        filtres: "Filtres",
        filter_mine_validator: "Demandes que je peux valider",
        filter_mine_creator: "Demandes que j'ai créées",
        filter_mine_agent: "Demandes qui concernent mes EPIs",
        refuser: "Refuser",
        refus: "Refus de la demande",
        refus_comment: "Commentaire de refus",
        bons_retrait: "Bons de retrait",
        create_bon_retrait: "Créer un bon de retrait",
        panier: "Panier",
        panierArticles: "Articles demandés",
        solde: "Clore la demande",
        solder: "Clore",
        solde_comment: "Commentaire de clôture",
        solde_confirmation_content: "Vous êtes sur le point de clore la demande. <br>Êtes-vous sûr de vouloir continuer ?",
        solde_success: "La demande a été clos avec succès",
        solde_error: "Erreur lors de la clôture de la demande. Veuillez vérifier les données saisies.",
        rubriques: "Rubriques",
        displayPanier: "Voir mon panier",
        cancel_confirmation: "Abandon du panier",
        cancel_confirmation_content: "Vous êtes sur le point d'abandonner le panier. <br>Êtes-vous sûr de vouloir continuer ?",
        totalHT: "Total HT",
        rubrique: "Rubrique",
        article: "Article",
        download_synthese: "Télécharger la synthèse",
        agents: "Agents",
        numeros: "Numéros de demandes",
        export_success: "L'export a été effectué avec succès",
        export_error: "Erreur lors de l'export des demandes. Veuillez contacter votre administrateur.",
        alert_stock: "Alerte stock faible ! Le stock de {0} est maintenant de {1} articles, ce qui est en dessous du seuil d'alerte ({2} articles). Vous pouvez néanmoins poursuivre votre demande car un ré-approvisionnement est en cours.",
        etats: {
            CREATION_EN_COURS: "En cours de création",
            VALIDATION_HIER_EN_COURS: "En attente de validation par {0}",
            VALIDATION_MIPOLEX_EN_COURS: "En attente de validation par MiPOLEX",
            PREPARATION_EN_COURS: "En cours de préparation",
            SOLDE: "Demande clos par {0}",
            REFUSE: "Demande refusée par {0}",
            error_status: "Erreur lors de la génération du statut de la demande.",
            VALIDATION0: "Demande traitée par le référent EPI",
            VALIDATION_HIER: "Validation par la hierarchie",
            VALIDATION_MIPOLEX: "Validation par MiPOLEX",
            REFUS: "Refusée",
            SOLDEE: "Clos",
        },
        const: {
            CREATION_EN_COURS: "En cours de création",
            VALIDATION_HIER_EN_COURS: "En attente de validation par la hiérarchie",
            VALIDATION_MIPOLEX_EN_COURS: "En attente de validation par MiPOLEX",
            PREPARATION_EN_COURS: "En cours de préparation",
            REFUSE: "Refusée",
            SOLDE: "Clos",
            COLIS_A_RETIRER: "Colis à retirer au stock",
            COLIS_RETIRE: "Colis retiré(s)",
        },
        tooltip: {
            quantiteDisponible: "Quantité actuellement en stock non encore affectée à des bons de retraits",
            "quantiteTotal": "Quantité totale d'articles demandés",
            "quantiteRestante": "Quantité totale d'articles en attente de retrait",
            "quantiteARetirer": "Quantité totale d'articles à retirés",
            "quantiteRetire": "Quantité totale d'articles retirés",
            quantitePanier: "Quantité totale d'articles de ce type demandés",
            sousdotation: "Sous-dotation ({0}/{1})",
            surdotation: "Sur-dotation ({0}/{1})",
            incorrect: "Article non présent dans la dotation de l'agent",
            creation_retour_en_cours: "La création d'un retour est en cours, merci de le finaliser avant de créer une nouvelle demande",
        },
    },
    "epiCommande": {
        list: "Liste des commandes",
        title: "Commandes d'EPI",
        dateCreated: "Date de création",
        numero: "Numéro de commande",
        numeroBonCommande: "Numéro de bon commande",
        numeroBonLivraison: "Numéro de bon de livraison",
        numeroDevis: "Numéro de devis",
        numeroEj: "Numéro d'EJ",
        numeroAccuseReception: "Numéro d'ARC",
        fournisseur: "Fournisseur",
        datePrevisionnelle: "Date prévisionnelle",
        dateEnvoiEj: "Date d'envoi de l'EJ",
        article: "Article",
        articleTooltip: "Article à commander",
        taille: "Taille",
        tailleTooltip: "Taille de l'article à commander",
        tailleLabel: "Taille",
        quantite: "Quantité",
        quantiteTooltip: "Quantité à commander",
        stockDisponible: "Stock disponible",
        stockDisponibleTooltip: "Stock disponible",
        prixUnitaireHt: "Prix unitaire HT",
        prixUnitaireHtTooltip: "Prix unitaire HT de l'article",
        rubrique: "Rubrique",
        rubriqueTooltip: "Rubrique de l'article",
        creator: "Créateur",
        create: "Créer",
        add: "Ajouter",
        cancel: "Annuler",
        create_commande: "Créer une commande",
        createTitle: "Créer une commande",
        createComment: "Commentaire de création de la commande",
        create_confirm_title: "Confirmation de création de commande",
        confirm: "Confirmer",
        msg_create_success: "La commande a été créée avec succès",
        createErrorNoArticle: "La commande ne peut pas être créée car aucun article n'a de quantité supérieure à 0",
        comment: "Commentaire",
        detail_title: "Détail de la commande",
        etats: {
            title: "État",
            CREE: "Créée",
            RECU: "Reçue",
        },
        updateTitle: "Modifier la commande",
        update_confirm_title: "Confirmation de modification de commande",
        updateConfirm: "Êtes-vous sûr de vouloir modifier la commande ?",
        msg_update_success: "La commande a été modifiée avec succès",
        updateErrorNoArticle: "La commande ne peut pas être modifiée car aucun article n'a de quantité supérieure à 0",
        mark_as_received: "Marquer comme reçue",
        reception_confirm_title: "Confirmation de réception de la commande",
        receptionConfirm: "Êtes-vous sûr de vouloir marquer la commande comme reçue ?",
        reception_error: "Erreur lors du passage de la commande au statut \"Reçue\" Veuillez vérifier les données saisies.",
        dateLivraison: "Date de livraison",
        reception_success: "La commande a été marquée comme reçue avec succès",
        filter_rubrique: "Filtrer par rubrique",
        filter_alerte: "Filtrer par article en seuil d'alerte",
        nbArticles: "Nombre d'articles",
        quantiteTotale: "Quantité totale",
        codeMarcheFournisseur: "Code marché",
    },
    "epiRetour": {
        photo: "Photo",
        designation: "Designation",
        tailleLabel: "Taille",
        motif: "Motif",
        motifs: "Motifs",
        detail: "Détail du retour / Déclaration de perte",
        retour_article: "Retour d'un article ou déclaration de perte d'un article",
        replacement_article: "Article de remplacement",
        replacement_taille: "Taille de remplacement",
        replacement_quantite: "Quantité de remplacement",
        replacement_qm: "Remplacement ?",
        quantite_retour: "Quantité à retourner",
        incomplete_field_error: "Tous les champs obligatoires n'ont pas été correctement saisis",
        disabledMessage: "Vous ne pouvez pas créer de nouveau retour tant que votre panier actuel n'est pas validé",
        ask_retour: "Demander un retour",
        resume_retour: "Continuer le retour en cours",
        "numero": "Numéro de retour",
        "commentaire": "Commentaire",
        "etat": "Etat",
        "status": "Statut",
        "statusDemande": "Statut de la demande",
        "quantiteTotal": "Nb total",
        "quantiteRestante": "En attente",
        "quantiteARetirer": "A retirer",
        "quantiteRetire": "Retiré",
        "articleNb": "Articles",
        "agentNb": "Agents",
        "prixTotalHt": "Prix total HT",
        "validators": "Valideurs",
        tooltip: {
            "quantiteTotal": "Quantité totale d'articles retournés",
            "quantiteRestante": "Quantité totale d'articles en attente de retrait",
            "quantiteARetirer": "Quantité totale d'articles à retirés",
            "quantiteRetire": "Quantité totale d'articles retirés",
            quantitePanier: "Quantité totale d'articles de ce type demandés",
            creation_demande_en_cours: "La création d'une demande est en cours, merci de la finaliser avant de créer un nouveau retour",
        },
        "title": "Retours/Pertes EPI",
        retour: "Retours",
        retourArticles: "Articles à retourner ou perdus",
        "list": "Liste des retours",
        "added": "Le retour a été ajoutée",
        "updated": "Le retour a été modifiée",
        "deleted": "Le retour a été supprimée",
        "create_dialog": "Création d'un retour",
        "edit_dialog": "Édition du retour",
        "delete_dialog": "Suppression du retour",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer le retour ?",
        "create_retour": "Créer un retour",
        "continue_demande": "Reprendre le panier",
        "retour_item_added": "Un article a été ajouté au retour",
        "error_replacement": "Erreur lors de la création du retour. Veuillez vérifier les données saisies.",
        "new_retour": "Nouvelle demande",
        "select_agent": "Sélection d'un agent",
        agent: "Agent",
        catalogue: "Catalogue",
        articles: "Articles",
        add_article_dialog: "Ajouter au panier",
        article_removed: "Article retiré du panier",
        taille: "Taille",
        quantiteRetournee: "Quantité retournée",
        quantite: "Quantité",
        cancel: "Abandonner",
        nom_agent: "Nom de l'agent",
        service_agent: "Service de l'agent",
        service: "Service",
        intitule_poste: "Poste",
        notifications_agents: "Notifier le(s) agent(s) par e-mail",
        code_dotation: "Code dotation",
        retour_canceled: "Le retour a été annulé",
        error_empty_cart_confirm: "Le panier est vide, impossible d'envoyer le retour",
        error_empty_cart_cancel: "Il n'y a pas de retour en cours",
        dateCreated: "Date de création",
        validate: "Valider",
        validation: "Validation",
        confirmation: "Confirmation",
        confirm: "Confirmer",
        validation_message: "Vous êtes sur le point de valider le retour. Êtes-vous sûr de vouloir continuer ?",
        duplicate: "Dupliquer",
        duplication: "Duplication",
        duplication_message: "Vous êtes sur le point de dupliquer la demande. Êtes-vous sûr de vouloir continuer ?",
        duplication_message_panier_present: "Vous avez déjà un panier en cours, il sera écrasé. Êtes-vous sûr de vouloir continuer ?",
        creator: "Créateur",
        validation_comment: "Commentaire de validation",
        etats: {
            CREATION_EN_COURS: "En cours de création",
            VALIDATION_HIER_EN_COURS: "En attente de validation par {0}",
            VALIDATION_MIPOLEX_EN_COURS: "En attente de validation par MiPOLEX",
            ACHEMINEMENT_EN_COURS: "En cours d'acheminement",
            RETOUR: "Retour acheminé par {0}",
            RETOUR2: "Retour acheminé",
            REFUSE: "Retour refusé par {0}",
            error_status: "Erreur lors de la génération du statut du retour.",
            VALIDATION0: "Retour validé par le référent EPI",
            VALIDATION_HIER: "Validation par la hiérarchie",
            VALIDATION_MIPOLEX: "Validation par MiPOLEX",
            REFUS: "Retour refusé",
        },
        const: {
            CREATION_EN_COURS: "En cours de création",
            VALIDATION_HIER_EN_COURS: "En attente de validation par la hiérarchie",
            VALIDATION_MIPOLEX_EN_COURS: "En attente de validation par MiPOLEX",
            PREPARATION_EN_COURS: "En cours de préparation",
            ACHEMINEMENT_EN_COURS: "En cours d'acheminement",
            REFUSE: "Refusée",
            RETOURNE: "Clos",
        },
        history: "Historique",
        filtres: "Filtres",
        filter_mine_validator: "Retours que je peux valider",
        filter_mine_creator: "Retours que j'ai créés",
        filter_mine_agent: "Retours qui concernent mes EPIs",
        refuser: "Refuser",
        refus: "Refus du retour",
        refus_comment: "Commentaire de refus",
        bons_retrait: "Bons de retrait",
        create_bon_retrait: "Créer un bon de retrait",
        panier: "Panier",
        retourner_articles: "Terminer",
        retourner: "Retourner",
        retourne: "Articles retournés",
        retour_comment: "Commentaire de retour",
        retour_confirmation_content: "Vous êtes sur le point de valider le retour des articles concernés. <br>Êtes-vous sûr de vouloir continuer ?",
        retour_success: "Le retour a été effectué avec succès",
        retour_error: "Erreur lors du retour. Veuillez vérifier les données saisies.",
        rubriques: "Rubriques",
        displayPanier: "Voir mon panier",
        voir_retour: "Voir le retour lié",
        voir_panier: "Voir le panier",
        voir_demande: "Voir la demande liée",
        voir_creation_retour: "Voir la création du retour",
        cancel_confirmation: "Annulation du retour",
        cancel_confirmation_content: "Vous êtes sur le point d'annuler le retour. <br>Êtes-vous sûr de vouloir continuer ?",
        cancel_panier: "Annuler le panier",
        motif_too_big: "Trop grand",
        motif_too_small: "Trop petit",
        motif_mismatch: "Ne correspond pas à ma demande",
        motif_miscellaneous: "Autre",
        motif_lost: "Perdu",
        motif_worn: "Usagé",
        motif_non_compliant: "Non conforme",
    },
    "epiBonRetrait": {
        download_bon: "Télécharger le bon de retrait",
        list: "Liste des bons de retrait",
        title: "Bon de retrait",
        navbar: "Bons de retrait EPI",
        create_bon: "Créer un bon de retrait",
        filter_mine: "Mes bons de retrait",
        select_demande: "Sélectionner une demande",
        demande: "Demande",
        designation: "Désignation",
        designationTooltip: "Désignation de l'article",
        taille: "Taille",
        tailleTooltip: "Taille de l'article",
        comment: "Commentaire",
        refDirif: "Référence DiRIF",
        refDirifTooltip: "Référence DiRIF de l'article",
        quantiteTotale: "Quantité demandée",
        quantiteTotaleTooltip: "Quantité totale demandée dans la demande",
        quantiteTraitee: "Quantité traitée",
        quantiteTraiteeTooltip: "Quantité déjà traitée dans la demande",
        quantiteDisponible: "Quantité disponible",
        quantiteDisponibleTooltip: "Quantité disponible en stock",
        quantiteMax: "Quantité maximale",
        quantiteMaxTooltip: "Quantité maximale qu'on peut encore affecter au bon de retrait",
        quantiteARetirer: "Quantité à retirer",
        quantiteARetirerTooltip: "Quantité pour le bon de retrait",
        date_retrait_previsionnel: "Date de livraison prévisionnelle",
        update_date_retrait_previsionnel: "Mettre à jour la date de livraison prévisionnelle",
        update_date_retrait_previsionnel_success: "Date de livraison prévisionnelle mise à jour avec succès",
        update_date_retrait_previsionnel_failed: "Echec de la mise à jour de la date de livraison prévisionnelle",
        update_date_retrait_previsionnel_required: "La date de livraison prévisionnelle est obligatoire",
        initializeQuantite: "Attribuer la quantité maximale",
        tooltip: {
            quantiteTotale: "Quantité totale d'articles de ce type demandés",
            quantiteTraitee: "Quantité traitée (articles en attente de retrait ou retirés) pour ce bon de retrait",
            quantiteDisponible: "Quantité disponible dans le stock de Villabé",
            quantiteMax: "Quantité maximale qui peut encore être retirée",
            quantiteARetirer: "Quantité à retirer dans ce bon de retrait",
            nbColisError: "Nombre de colis retiré incorrect. Veuillez vérifier la raison de cette incohérence.",
            nbColis: "Nombre de colis retirés / Nombre de colis prévus pour ce bon de retrait",
        },
        quantite: "Quantité",
        create: {
            title: "Créer",
            error_empty_quantities: "Erreur lors de la création du bon de retrait. Veuillez vérifier les quantités à retirer.",
            popup_title: "Création du bon de retrait",
            confirm: "Confirmer",
            error: "Erreur lors de la création du bon de retrait. Veuillez vérifier les données saisies.",
            success: "Le bon de retrait a été créé",
            ws_error: "Erreur lors de la création du bon de retrait. Veuillez vérifier les données saisies ainsi que le stock pour cet article.",
            error_invalid_quantities: "Erreur lors de la création du bon de retrait. Veuillez vérifier les quantités à retirer. Il y a au moins une quantité supérieure à la quantité disponible.",
        },
        nb_colis: "Nombre de colis",
        numero_demande: "Demande",
        numero_bon_retrait: "Bon de retrait",
        articles: "Articles",
        creator: "Créateur",
        date_creation: "Date de création",
        date_retrait: "Date de retrait",
        error_invalid_command: "Identifiant de la demande invalide. Veuillez le vérifier et réessayer.",
        demande_link: "Consulter la demande liée",
        date_creation_demande: "Date de création de la demande",
        no_retrait_demande: "N° du bon de retrait pour cette demande",
        no_retrait_demande_liste: "N° bon/demande",
        status: {
            title: "Statut",
            EN_COURS: "En cours de préparation",
            A_RETIRER: "Colis à retirer",
            RETIRE: "Colis retiré(s)",
            DISTRIBUTION_EN_COURS: "En cours de distribution",
            SOLDE: "Clos",
            bon_a_retirer_success: "Le bon de retrait a été noté comme \"À retirer\" avec succès.",
            bon_retire_success: "Le bon de retrait a été noté comme \"Retiré\" avec succès.",
            bon_status_error: "Erreur lors de la mise à jour du statut du bon de retrait. Veuillez vérifier les données saisies.",
            update_bon_a_retirer: "Indiquer que les colis sont prêts à être retirés",
            update_bon_a_retirer_message: "Vous êtes sur le point de mettre à jour le statut du bon de retrait pour le statut \"À retirer\". <br>Êtes-vous sûr de vouloir continuer ?",
            update_bon_retire: "Indiquer que les colis sont retirés",
            update_bon_retire_message: "Vous êtes sur le point de mettre à jour le statut du bon de retrait pour le statut \"Retiré\". <br>Êtes-vous sûr de vouloir continuer ?",
            update_bon_status_error: "Etat incorrect. Veuillez contacter l'administrateur.",
            ws_bon_status_error: "Erreur lors de la mise à jour du statut du bon de retrait. Veuillez vérifier les données saisies ainsi que le stock pour cet article.",
        },
        create_bon_retrait: "Créer un bon de retrait",
        bons_retrait: "Bons de retrait liés",
        retrait_by: "Retiré par",
        nb_colis_retire: "Nombre de colis retirés",
        date_solde: "Date de clôture",
        comment_solde: "Commentaire de clôture",
        dispatch: {
            title: "Distribuer",
            titleAll: "Distribuer tout",
            articles: "Articles",
            designation: "Désignation",
            taille: "Taille",
            quantiteInitiale: "Quantité initiale",
            quantiteRestante: "Quantité restante",
            quantiteADistribuer: "Quantité à distribuer",
            dispatchAll_confirmation_content: "Vous êtes sur le point de distribuer tout pour l'agent sélectionné. <br>Êtes-vous sûr de vouloir continuer ?",
            dispatchFull_confirmation_content: "Vous êtes sur le point de distribuer tout pour l'ensemble des agents. <br>Êtes-vous sûr de vouloir continuer ?",
            distribution: "Distribution",
            distribution_confirmation_content: "Saisissez le nombre d'articles à distribuer à cet agent. En cliquant sur \"Distribuer\", vous confirmez la distribution de ces articles à l'agent sélectionné. <br>Êtes-vous sûr de vouloir continuer ?",
            success: "La distribution a été effectuée avec succès",
            error: "Erreur lors de la distribution. Veuillez vérifier les données saisies.",
            solde: "Clore le bon de retrait",
            solder: "Clore",
            solde_confirmation_content: "Vous êtes sur le point de clore le bon de retrait alors que tous les articles ne sont pas encore distribués. <br>Êtes-vous sûr de vouloir continuer ?",
            solde_success: "Le bon de retrait a été clos avec succès",
            solde_error: "Erreur lors du solde. Veuillez vérifier les données saisies.",
            auto_solde_success: "Le bon de retrait a été clos automatiquement suite à la distribution de tous les articles",
            articles_a_distribuer: "Articles à distribuer pour {0}",
            articles_a_distribuer_vide: "Aucun article à distribuer",
            articles_distribues: "Articles distribués à {0}",
            articles_distribues_vide: "Aucun article de distribué",
            demande: "Demande liée",
            bon_retrait: "Bon de retrait lié",
            quantitePossedee: "Quantité possédée",
            dotation: "Dotation",
            dotation_incorrect: "Article non présent dans la dotation de l'agent",
            dispatch_incorrect: "L'article distribué ne correspond pas à la demande initiale",
            sur_dotation: "L'agent est déjà sur-doté de {0} article(s) pour cet EPI avant la distribution",
            sur_dotation_dispatch: "L'agent sera sur-doté de {0} article(s) pour cet EPI après la distribution",
            sous_dotation: "L'agent est sous-doté de {0} article(s) pour cet EPI avant la distribution",
            sous_dotation_dispatch: "L'agent sera sous-doté de {0} article(s) pour cet EPI après la distribution",
            distribution_non_conforme_confirmation_content: "La distribution que vous vous apprêtez à faire n'est pas conforme à la demande de l'agent. Êtes-vous sûr de vouloir continuer ?",
        }
    },
    "epiStock": {
        prixUnitaireHtTooltip: "Prix unitaire HT de l'article",
        prixUnitaireHt: "Prix unitaire HT",
        valeurStockHt: "Valeur de l'inventaire HT",
        valeurStockHtTooltip: "Valeur de l'inventaire HT",
        list: "Stock d'EPI",
        title: "Stock d'EPI",
        updateTitle: "Inventaire du stock d'EPI",
        alerteUpdateTitle: "Modification du seuil d'alerte",
        update: "Mettre à jour",
        navbar: "Stock d'EPI",
        msg_update_success: "Stock mis à jour avec succès",
        msg_update_alerte_success: "Seuil d'alerte mis à jour avec succès",
        inventaire: "Inventaire",
        alert_update: "Modifier le seuil d'alerte",
        export_success: "L'export du stock a été effectué avec succès",
        export_error: "Erreur lors de l'export du stock. Veuillez contacter votre administrateur.",
        rubrique: "Rubrique",
        article: "Article",
        taille: "Taille",
        quantiteStock: "Quantité en stock",
        quantiteDemande: "Quantité demandée",
        quantiteBonRetrait: "Quantité en attente de retrait",
        quantiteAFournir: "Reliquat des demandes",
        quantiteDisponible: "Quantité disponible",
        seuilAlerte: "Seuil d'alerte",
        
        rubriqueTooltip: "Rubrique de l'article en stock",
        articleTooltip: "Désignation de l'article en stock",
        tailleTooltip: "Taille de l'article en stock",
        quantiteStockTooltip: "Quantité actuellement en stock",
        quantiteDemandeTooltip: "Quantité totale dans des demandes en cours",
        quantiteBonRetraitTooltip: "Quantité totale dans des bons de retrait",
        quantiteAFournirTooltip: "Quantité dans des demandes en cours qui ne sont pas encore honorées",
        quantiteDisponibleTooltip: "Quantité actuellement en stock non encore affectée à des bons de retraits",
        seuilAlerteTooltip: "Seuil d'alerte sur la quantité disponible en stock",
        
        inventaireQuantiteStockTooltip: "Quantité réelle au moment de l'inventaire",
    },
    "epiRubrique": {
        "enabled": "Actif",
        "description": "Description",
        "path": "Chemin complet",
        "parent": "Rubrique parent",
        "pathDetailed": "Chemin complet (Exemple : 100/120)",
        "name": "Nom",
        "title": "Rubriques",
        "list": "Liste des rubriques",
        "added": "La rubrique a été ajoutée",
        "updated": "La rubrique a été modifiée",
        "deleted": "La rubrique a été supprimée",
        "createroot_dialog": "Création d'une rubrique",
        "createnode_dialog": "Création d'une sous-rubrique de {0}",
        "edit_dialog": "Édition de la rubrique",
        "delete_dialog": "Suppression de la rubrique",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer la rubrique ?",
    },
    "epiMouvement": {
        list: "Liste des mouvements d'EPI",
        create_title: "Créer un nouveau mouvement",
        detail_title: "Détail du mouvement",
        add: "Ajouter",
        create: "Créer",
        cancel: "Annuler",
        title: "Mouvements d'EPI",
        dateCreated: "Date de création",
        creator: "Créateur",
        article: "Article",
        taille: "Taille",
        quantite: "Quantité (indiquer un chiffre négatif si c'est une diminution du stock)",
        tailleLabel: "Taille",
        typeLabel: "Type",
        articleTailleCount: "Nombre d'articles",
        comment: "Commentaire",
        confirmation_create: "Confirmation de création de mouvement",
        confirmation_inventaire: "Confirmation de validation de l'inventaire",
        confirm: "Confirmer",
        msgErr_article: "Vous devez choisir un article",
        msgErr_taille: "Vous devez saisir une taille pour votre article",
        msgErr_quantite: "Vous devez saisir une variation de stock pour votre article",
        msgErr_items: "Vous devez ajouter des articles au mouvement",
        type: {
            title: "Type de mouvement",
            INVENTAIRE: "Inventaire",
            RETOUR: "Retour",
            RETRAIT: "Retrait",
            MANUEL: "Manuel",
            COMMANDE: "Commande",
        }
    },
    "incivilite_agression": {
        title: "Incivilités et agressions",
        comment: "Commentaire",
        question: "Un agent de la DiRIF a t-il été victime d'une incivilité ou d'une agression durant l'intervention ?"
    },
    "profile": {
        myProfile: "Mon profil",
        codeDotation: "Code dotation",
        email: "Email",
        service: "Service",
        groupes: "Groupes",
        referents: "Référents EPI",
        dotationTypes: "Dotations type",
        departement: "Département",
        unite: "Unité",
        poste: "Poste",
        hierarchie: "Supérieur hiérarchique",
        validators: "Chaine hiérarchique EPI",
        informations: "Informations",
        tourTete: "Tour de tête (cm)",
        tourPoitrine: "Tour de poitrine (cm)",
        tourTaille: "Tour de taille (cm)",
        tourBassin: "Tour de bassin (cm)",
        hauteurHaut: "Hauteur haut (de la tête à la taille en cm)",
        hauteurBas: "Hauteur bas (de la taille aux pieds en cm)",
        entrejambe: "Entrejambe (cm)",
        stature: "Stature de l'agent (cm)",
        gants: "Taille des gants",
        pointure: "Pointure du pied (extrémité du pouce au talon)",
        commentaireHierarchie: "Commentaire de la hiérarchie",
        mensurations: {
            title: "Mensurations",
            updated: "Les mensurations ont été mises à jour",
            update: "Mettre à jour les mensurations",
            informations: "Informations au sujet des mensurations",
            infographie: "Infographie des mensurations",
        },
        dotations_reelles: {
            current_epi: "Dotations en cours",
            no_current_epi: "Aucune dotation en cours",
            title: "Dotations réelles",
            past_epi: "Dotations passées",
            no_past_epi: "Aucune dotation passée",
            editTitle: "Choisir les dotations réelles de {0}",
            editAction: "Choisir les dotations réelles",
            added: "Dotation réelle ajoutée",
            removed: "Dotation réelle supprimée",
            quantite: "Quantité",
            error_edit: "Une erreur est survenue lors de la modification des dotations réelles.",
            taille: "Taille",
            article: "Article",
            add: "Ajouter",
            msgErr_article: "Vous devez choisir un article",
            msgErr_taille: "Vous devez saisir une taille pour votre article",
            msgErr_quantite: "Vous devez saisir une quantité pour votre article",
        },
        dotations_type: {
            title: "Dotations type",
            status: "Statut",
            code: "Code",
            profilActivite: "Profil/Activité",
            rule: "Règle",
            description: "Description",
            empty: "Aucune dotation type à afficher. Il faut configurer le code dotation de l'agent pour afficher les dotations type associées si il y en a.",
        },
        dotations_custom: {
            complete: "Dotation valide",
            incomplete: "Dotation incomplète",
            editMyselfTitle: "Choisir mes dotations",
            editTitle: "Choisir les dotations de {0}",
            editAction: "Choisir les dotations",
            title: "Dotations choisies",
            rubrique: "Rubrique",
            tailleLabel: "Taille",
            quantite: "Quantité",
            error_edit: "Erreur lors de la modification des dotations. La dotation personnalisée est invalide pour la règle de dotation type actuelle.",
            error_taille_label: "Il faut saisir une taille pour chaque dotation personnalisée dont la quantité est différente de 0.",
        },
        alertes_dotations: {
            title: "Alertes de dotations",
            surdotation: "Sur-dotation",
            sousdotation: "Sous-dotation",
            alerte: "Alerte",
            rubrique: "Rubrique",
        },
        activites: "Activités spécifiques",
        demandes: "Demandes en cours de l'utilisateur",
        date_created: "Date de création",
        creator_name: "Créateur",
        numero_demande: "Numéro",
        statut: "Statut",
    },
    "epiAgent": {
        list: "Liste des agents",
        not_validated_list: "Liste des agents à valider",
        title: "Agents",
        not_validated_title: "Agents à valider",
        "prenom": "Prénom",
        "nom": "Nom",
        "added": "L'agent a été ajouté",
        "updated": "L'agent a été modifié",
        "deleted": "L'agent a été supprimé",
        "create_dialog": "Création d'un agent",
        "edit_dialog": "Édition de l'agent",
        "delete_dialog": "Suppression de l'agent",
        "confirm_delete": "Êtes-vous sûr de vouloir supprimer l'agent ?",
        codePoste: "Code poste",
        intitulePoste: "Intitulé du poste",
        service: "Service",
        tel: "Téléphone",
        enabled: "Actif",
        validate_dialog: "Validation de l'agent",
        emailLogin: "E-mail (Login)",
        password: "Mot de passe",
        agent_validated: "L'agent a été validé",
        validated: "Validé",
        nouvelArrivant: "Nouvel arrivant",
    },
    upload: "Téléverser",
    delete: "Supprimer",
    type_axe: {
        echangeur: "Échangeur",
        bretelle: "Bretelle",
        section_courante: "Section courante",
    },
    type_echangeur: {
        numero: "Numéro",
        bretelle: "Bretelle",
    },
    tech_type_axe: {
        a: "A",
        rn: "RN",
        rd: "RD",
        autre: "Autre",
    },
    file_error: "Erreur lors de l'envoi du/des fichier(s), vérifiez la taille et le type du/des fichier(s).",
    value_already_exists: "La valeur saisie existe déjà",
    "charte": {
        title: "Charte d'utilisation de CIT-Ex",
        non_diffusion: "Engagement de non diffusion de l'information",
        accept: "J'accepte la charte d'utilisation de CIT-Ex",
        accepted: "La charte d'utilisation de CIT-Ex et l'engagement de non diffusion de l'information a été acceptés.",
        not_accepted: "Une erreur est survenué lors de l'acceptation de la charte d'utilisation de CIT-Ex et de l'engagement de non diffusion de l'information. Vous les avez peut-être déjà acceptés.",
    },
    "progression": {
        title: "Avancement",
        steps: {
            creation: "Création",
            validation_hier: "Validation hiérarchique",
            validation_mipolex: "Validation MiPOLEX",
            preparation: "Préparation",
            refus: "Refus",
            en_cours: "En cours de préparation",
            distribution_en_cours: "En cours de distribution",
            a_retirer: "À retirer",
            retire: "Retiré",
            clos: "Clos",
            solde: "Clos",
            acheminement: "En cours d'acheminement",
            retourne: "Retour acheminé",
        },
        tooltip: {
            en_cours: "Étape en cours",
            termine: "Étape terminée",
            refus: "Étape refusée",
            en_attente: "Étape en attente",
        }
    },
    "epiPreDemande": {
        confirmation_content: "Vous êtes sur le point de créer une demande. <br>Êtes-vous sûr de vouloir continuer ?",
        accept_article: "Accepter l'article",
        accept_article_content: "Vous êtes sur le point d'accepter l'article. Il sera ajouté à votre panier.<br>Êtes-vous sûr de vouloir continuer ?",
        accept_article_selection: "Accepter les articles sélectionnés",
        accept_article_content_selection: "Vous êtes sur le point d'accepter les articles suivants: --articlesDisplay--<br><br>Ils seront ajoutés à votre panier.<br>Êtes-vous sûr de vouloir continuer ?",
        article_accept: "L'article a été accepté et ajouté à votre panier",
        article_accept_selection: "Les articles sélectionnés ont été acceptés et ajoutés à votre panier",
        error_accept_article: "Une erreur est survenue lors de l'acceptation de l'article. Veuillez réessayer.",
        error_accept_article_selection: "Une erreur est survenue lors de l'acceptation des articles sélectionnés. Veuillez réessayer.",
        error_article: "Erreur lors de l'acceptation de l'article. Veuillez vérifier les données saisies.",
        accepte: "Acceptée",
        status: "Statut",
        const: {
            ACCEPTEE: "Acceptée par le référent EPI",
            REFUSEE: "Refusée par le référent EPI",
            ATTENTE_VALIDATION: "En attente de traitement par le référent EPI",
            ACCEPTEE_PARTIELLEMENT: "Acceptée partiellement par le référent EPI",
        },
        accept: "Accepter",
        acceptSelection: "Accepter la sélection",
        acceptSelectionTooltip: "Sélectionner d'abord vos articles puis cliquer sur le bouton \"Accepter la sélection\"",
        acceptAll: "Accepter tout",
        disabledMessage: "Vous ne pouvez pas accepter d'article dans votre panier tant que votre retour actuel n'est pas validé",
        tooltip: {
            creation_retour_en_cours: "Le retour d'EPI est en cours de création, vous ne pouvez pas accepter d'article dans votre panier",
            demande_en_cours_de_creation: "La demande est en cours de création. Vous pourrez la consulter une fois créée.",
        },
        duplication_message: "Vous êtes sur le point de dupliquer la demande. <br>Les articles dupliqués seront ajouté à votre panier. <br>Êtes-vous sûr de vouloir continuer ?",
        acceptAll_message: "Vous êtes sur le point d'accepter tous les articles de la demande. <br>Êtes-vous sûr de vouloir continuer ?",
        parametre_duplication: "Paramètre de duplication",
        parametre_duplication_all: "Dupliquer tous les articles",
        parametre_duplication_not_accepted: "Dupliquer les articles non acceptés",
        duplication_success: "La demande a été dupliquée et les articles ajoutés à votre panier",
        duplication_error: "Erreur lors de la duplication de la demande. Veuillez vérifier les données saisies.",
    },
    "epiPreRetour": {
        confirmation_content: "Vous êtes sur le point de créer un retour. <br>Êtes-vous sûr de vouloir continuer ?",
        accept_article: "Accepter l'article",
        accept_article_content: "Vous êtes sur le point d'accepter l'article. Il sera ajouté à votre panier.<br>Êtes-vous sûr de vouloir continuer ?",
        accept_article_selection: "Accepter les articles sélectionnés",
        accept_article_content_selection: "Vous êtes sur le point d'accepter les articles suivants: --articlesDisplay--<br><br>Ils seront ajoutés à votre panier.<br>Êtes-vous sûr de vouloir continuer ?",
        article_accept: "L'article a été accepté et ajouté à votre panier",
        article_accept_selection: "Les articles sélectionnés ont été acceptés et ajoutés à votre panier",
        error_accept_article: "Une erreur est survenue lors de l'acceptation de l'article. Veuillez réessayer.",
        error_accept_article_selection: "Une erreur est survenue lors de l'acceptation des articles sélectionnés. Veuillez réessayer.",
        error_article: "Erreur lors de l'acceptation de l'article. Veuillez vérifier les données saisies.",
        accepte: "Accepté",
        status: "Statut",
        const: {
            ACCEPTEE: "Accepté par le référent EPI",
            REFUSEE: "Refusé par le référent EPI",
            ATTENTE_VALIDATION: "En attente de traitement par le référent EPI",
            ACCEPTEE_PARTIELLEMENT: "Accepté partiellement par le référent EPI",
        },
        accept: "Accepter",
        acceptSelection: "Accepter la sélection",
        acceptSelectionTooltip: "Sélectionner d'abord vos articles puis cliquer sur le bouton \"Accepter la sélection\"",
        acceptAll: "Accepter tout",
        disabledMessage: "Vous ne pouvez pas accepter d'article dans votre panier tant que votre retour actuel n'est pas validé",
        tooltip: {
            creation_retour_en_cours: "Le retour d'EPI est en cours de création, vous ne pouvez pas accepter d'article dans votre panier",
            retour_en_cours_de_creation: "Le retour est en cours de création. Vous pourrez la consulter une fois créée.",
        },
        duplication_message: "Vous êtes sur le point de dupliquer le retour. <br>Les articles dupliqués seront ajouté à votre panier. <br>Êtes-vous sûr de vouloir continuer ?",
        parametre_duplication: "Paramètre de duplication",
        parametre_duplication_all: "Dupliquer tous les articles",
        parametre_duplication_not_accepted: "Dupliquer les articles non acceptés",
        duplication_success: "Le retour a été dupliquée et les articles ajoutés à votre panier",
        duplication_error: "Erreur lors de la duplication de la retour. Veuillez vérifier les données saisies.",
    },
    epiDotationReelle: {
        import: {
            title: "Importer les dotations réelles",
            imported: "Les dotations réelles ont été importées avec succès",
            error: "Erreur lors de l'import des dotations réelles. Veuillez vérifier le format du fichier importé.",
            no_file_selected: "Aucun fichier sélectionné. Veuillez sélectionner un fichier à importer.",
        }
    }
};